const Constants = Object.freeze({
  // -----------------------------------------------------------------------------
  // -------------------------------- PROTOCOL ----------------------------------
  // -----------------------------------------------------------------------------

  // ---------------------------- HOME ----------------------------
  TIME_ON: "Uptime: ",
  NUM_OF_DEVICES: "Number of devices",
  MASTERS: "Masters",
  SLAVES: "Slaves",
  STATISTICS: "Statistics",

  NO_RETRIES: "No retries",

  BAUD_RATE_KBPS: "BAUD RATE (Kbps)",
  BAUD_RATE_MBPS: "BAUD RATE (Mbps)",

  CYCLE_TIME_S: "CYCLE TIME (s)",
  CYCLE_TIME_MS: "CYCLE TIME (ms)",

  WATCHDOG_MS: "WATCHDOG (ms)",

  RETRIES_LIMIT: "RETRY LIMIT",

  PROFIBUS_NETWORK_INFO: "PROFIBUS network information",

  HSA_POPUP_1: "HSA (Highest PROFIBUS Address) is the parameter that indicates the highest address the master searches for new devices on the network, using the FDL_Status protocol.",
  HSA_POPUP_2: "Also used for detecting class 2 masters or networks with more than one master.",

  // ---------------------------- Live List ----------------------------
  AVAILABILITY: "Availability",
  TAG: "Tag",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  REASON: "\nReason: ",

  EXPORT_CSV: "Export XLSX",
  CSV_HEADER: "Address,Tag,Model,Diagnostics,Retries without faults,Total retries,Faults,Availability,Watchdog,Status\n",

  PAGE: "Page",

  YEAR: " year",
  MONTH: " month",
  MONTHS: " months",
  DAY: " day",
  HOUR: " hour",
  MINUTE: " minute",
  SECOND_T: " second",

  // ---------------------------- Log ----------------------------
  MANUFACTURER_MODEL: "Manufacturer / Model",

  // ---------------------------- Configuration page related ----------------------------
  LOGIN_CREDENTIALS_FAILURE: "An error occurred while logging in: Incorrect username or password.",
  LOGIN_GENERAL_FALIURE: "An error occurred while logging in:",

  GPG_ALERT_MESSAGE: "Only files with the .gpg extension can be sent",
  SEND_FILE_FAILURE: "An error occurred while sending the file.",
  SEND_FILES_SUCCESS: "The files were sent successfully.",
  SEND_FILE_WAITING: "Sending file.",
  SEND_FILE_WRONG_FILENAME: "Invalid name. The update file must be named: updatePRO.tar.gz.gpg",
  SEND_FILE_CORRUPTED_FILE: "The update file was corrupted during upload.",

  SEND_CONFIG_FAILURE: "An error occurred while sending the settings.",
  SEND_CONFIG_WAITING: "Sending settings.",
  SEND_CONFIG_WAITING_2: "Finalizing settings upload.",
  SEND_CONFIG_DONE: "Settings sent.",
  SEND_NTP_CONFIG_WAITING: "Sending NTP server settings.",
  SEND_NTP_CONFIG_DONE: "NTP server settings sent.",

  WAITING: "Please wait a moment",
  CLEAN_LOG_SUCCESS: "The log was cleared successfully.",
  CLEAN_LOG_FAILURE: "An error occurred while clearing the log.",
  CLEAN_STATISTICS_SUCCESS: "The statistics were cleared successfully.",
  CLEAN_STATISTICS_FAILURE: "An error occurred while clearing the statistics.",

  CHANGE_USERNAME_SUCCESS: "The username was changed successfully. Please log in again.",
  CHANGE_USERNAME_FAILURE: "An error occurred while changing the username: ",
  USERNAME_TOO_SHORT: "The username must contain at least one character.",
  PASSWORD_MISSMATCH: "The entered passwords do not match",
  CHANGE_PASSWORD_SUCCESS: "The password was changed successfully. Please log in again.",
  CHANGE_PASSWORD_FAILURE: "An error occurred while changing the password: ",

  VERIFY_THE_FOLLOWING_INFO: "Please check the following information:",
  INVALID_IP: "\n- The entered IP is invalid",
  INVALID_SUBMASK: "\n- The entered subnet mask is invalid",
  INVALID_GATEWAY: "\n- The entered gateway is invalid",
  INVALID_DNS: "\n- The entered DNS is invalid",
  LOOPBACK_IP: "\n- The loopback IP (127.0.0.1) cannot be used as the monitor IP",
  LOOPBACK_IP_NTP: "\n- The loopback IP (127.0.0.1) cannot be used as the NTP server IP",
  SELECT_TIMEZONE: "\n- A timezone must be selected to configure the NTP server",
  SAME_SUBNET_IP_1: "\n- The IP address of the WLAN interface cannot be on the same subnet as the ETHERNET interface.",
  SAME_SUBNET_IP_2: "\n- The IP address of the ETHERNET interface cannot be on the same subnet as the WLAN interface.",
  SUBNET_OVERLAP_WLAN: "\n- TS Monitor PROFIBUS PRO detected an address overlap between the ETHERNET interface subnet and the WLAN subnet. For this reason, it is not possible to configure the WLAN with the selected IP address and mask.",
  SUBNET_OVERLAP_ETHERNET_WLAN: "\n- TS Monitor PROFIBUS PRO detected an address overlap between the ETHERNET interface subnet and the WLAN subnet. For this reason, it is not possible to configure the ETHERNET interface with the selected IP address and mask.",
  ZERO_IP_MSG: "\n- IP 0.0.0.0 cannot be used as the TS Monitor PROFIBUS PRO IP",
  ZERO_IP_MASK_MSG: "\n- IP 0.0.0.0 cannot be used as the network mask",
  BROADCAST_IP_MSG: "\n- The network broadcast IP cannot be used as the TS Monitor PROFIBUS PRO IP",
  NETWORK_IP_MSG: "\n- The network IP cannot be used as the TS Monitor PROFIBUS PRO IP",
  BROADCAST_GATEWAY_MSG: "\n- The network broadcast IP cannot be used as the gateway IP",
  NETWORK_GATEWAY_MSG: "\n- The network IP cannot be used as the gateway IP",

  EMPTY_WIFI_PWD: "\n- The Wi-Fi password cannot be empty",

  ALTER_USERNAME: "CHANGE USERNAME",
  ALTER_PASSWORD: "CHANGE PASSWORD",

  RESTART_SYSTEM: " Restart system",
  CONFIRM_RESTART_SYSTEM: "Are you sure you want to restart the system?",
  RESTART_SYSTEM_FAILURE: "An error occurred while trying to restart the system.",
  RESTART_SYSTEM_SUCCESS: "Restart request sent successfully. Please wait about 3 minutes for the system to restart completely.",

  SELECT_FILE: "Please select a file to upload",
  SELECT_GSD_FLIE: "Please select at least one GSD file to upload",
  SENDING_GSD_FILES: "Sending GSD files",

  DO_NOT_CLOSE_THIS_TAB: "Keep this tab open to follow the update.",
  UPDATING_MONITOR_FILES: "Updating files on the monitor. Please wait.",
  MONITOR_FILES_UPDATED_SUCCESSFULLY: "Files updated, preparing to restart the monitor.",
  RESTARTING_MONITOR_WAIT: "Restarting monitor, please wait a few minutes.",
  UPDATE_SUCCESS: "The update was completed successfully!",
  UPDATE_ERROR_STRING: "The following error occurred while updating the monitor: ",

  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS: "Modify at least one of the fields to update the interface settings.",
  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS_WLAN: "Modify at least one of the fields to update the WLAN settings.",

  TAG_WAS_CHANGED_SUCCESSFULLY: "The monitor tag was changed successfully.",
  TAG_CHANGE_FAILURE: "An error occurred while changing the monitor tag.",

  REMEMBER_TO_UPDATE_BROWSER_ADDRESS_TO: "\nRemember to update the browser address to: ",
  UPDATE_INTERFACE_CONFIG_SUCCESS: "The interface settings were updated successfully!",
  UPDATE_WLAN_CONFIG_SUCCESS: "The WLAN settings were updated successfully!",

  THE_FOLLOWING_FILES_COULD_NOT_BE_SENT: "An error occurred while sending the following GSD files: ",
  THE_FOLLOWING_FILES_COULD_NOT_BE_REMOVED: "An error occurred while removing the following GSD files: ",

  MANAGE: "Manage",

  TAG_CONFIG: "Network tag",

  ETHERNET: "Ethernet",
  ETHERNET_POPUP_1: "Ethernet interface configuration field.",
  ETHERNET_POPUP_2: "Used for supervision and Web access to monitor data.",

  WLAN: "WLAN",
  WLAN_POPUP_1: "Wireless interface configuration field, when an adapter is available.",
  WLAN_POPUP_2: "Used for supervision and Web access to monitor data.",

  NTP_SERVER: "NTP Server",

  TURN_NTP_SERVER_ON: "Turn on NTP server",
  TURN_NTP_SERVER_ON_QUESTION: "Are you sure you want to turn on the NTP server? The monitor will need to be restarted for this.",

  NTP_INFO_TURNED_ON_FAILURE: "An error occurred while turning on the NTP server.",

  PROCESSING_NTP_INIT: "Starting NTP server information processing",
  PROCESSING_NTP_INFO: "Processing NTP server information.",
  PROCESSED_NTP_INFO: "NTP server information processed.",
  PROCESSING_NTP_ERROR: "An error occurred while sending information to the NTP server. Check whether the server IP address is correct. If it is, also verify that the NTP service is enabled and try again.",

  MONITOR_RESTART_SUCCESS: "The monitor was restarted successfully.",
  MONITOR_RESTART_FAILURE: "An error occurred while restarting the monitor.",

  NTP_INFO_TURNED_OFF_FAILURE: "An error occurred while turning off the NTP server.",
  NTP_INFO_FAILURE: "Failed to synchronize with the server. If the error persists, contact the NTP server administrator.",

  SEND_WLAN_CONFIG_WAITING: "Sending settings, please wait. This may take about one minute.",
  UPDATE_WLAN_CONFIG_ERROR: "Could not connect to the WLAN network. If the problem persists, try restarting the monitor or the WLAN router.",

  ALTER_MONITOR_CONFIG: "Are you sure you want to change the monitor settings?",
  IP: "IP",
  EDIT: "Edit",
  CLEAR: "Clear",
  ALTER: "Change",
  REPORT: "Report",
  ALTER_LOGIN: "Change login",
  SEND: "Send",
  GSD_FILES: "GSD files",
  SOFTWARE_UPDATE: "Software Update",
  CURRENT_VERSION: "Current version: ",
  UPDATE: "Update",

  TEST_NETWORK: "Test network",
  USER: "Usuario",
  NEW_PASSWORD: "Nueva contraseña",
  REPEAT_PASSWORD: "Repetir contraseña",
  TIMEZONE: "Timezone",
  DHCP: "DHCP",
  FIXED_IP: "Fixed IP",

  // ---------------------------- WLAN Config ----------------------------
  WLAN_STATUS: "WLAN adapter",
  WLAN_CONFIG: "WLAN settings",
  CONNECTION_STATUS: "Connection status",

  WLAN_ADAPTER_ON: "On",
  WLAN_ADAPTER_OFF: "Off",

  IP_PLACEHODLER: "192.168.2.215",
  SSID: "SSID",
  SIGNAL_STRENGTH: "Signal strength",
  FREQUENCY: "Frequency",
  CHANNEL: "Channel",
  QUALITY: "Quality",

  SSID_PLACEHOLDER: "SSID",
  MAC_PLACEHOLDER: "A0:8C:FD:19:DB:02",
  SIGNAL_STRENGTH_PLACEHOLDER: "90 dBm",
  FREQUENCY_PLACEHOLDER: "2.4GHz",
  CHANNEL_PLACEHOLDER: "1",
  QUALITY_PLACEHOLDER: "Quality",

  TURNING_WLAN_OFF_WAITING: "Turning off the WLAN adapter, please wait.",
  TURNING_WLAN_ON_WAITING: "Turning on the WLAN adapter, please wait.",

  NETWORK: "Network",
  NETWORK_NAME_1: "Network name",
  SUBMASK: "Subnet mask",
  GATEWAY: "Gateway",
  PASSWORD: "Password",

  ALTER_MONITOR_WLAN_CONFIG: "Are you sure you want to change the monitor WLAN settings?",

  CONNECTED: "Connected",
  DISCONNECTED: "Disconnected",

  WLAN_STATUS_POPUP_1: "Indicates the status of the monitor WLAN adapter.",
  WLAN_STATUS_POPUP_2: "If it is turned off, it is not possible to change the WLAN settings.",

  CONNECTION_STATUS_POPUP_1: "Indicates whether the monitor is connected to the configured WLAN network or not.",

  WLAN_CONFIG_POPUP_1: "It is not possible to change the settings while the WLAN adapter is turned off.",
  WLAN_CONFIG_POPUP_2: "It is highly recommended that WLAN settings be changed only when accessing the monitor through the wired network.",
  WLAN_CONFIG_POPUP_3: "When changing the IP / subnet mask, if the fields appear blank after the update, this is a strong indication that:",
  WLAN_CONFIG_POPUP_4: "There is already another device on the network with the same IP;",
  WLAN_CONFIG_POPUP_5: "The subnet mask is too restrictive and does not support the provided IP.",

  WLAN_ADAPTER_NOT_FOUND_1: "TS Monitor PROFIBUS PRO could not find the WLAN adapter:\n",
  WLAN_ADAPTER_NOT_FOUND_2: "  • Check whether the adapter is disconnected or has a poor connection;\n",
  WLAN_ADAPTER_NOT_FOUND_3: "  • If the adapter is neither disconnected nor has a poor connection, try replacing it;\n",
  WLAN_ADAPTER_NOT_FOUND_4: "  • If none of the above options solve the problem, contact Toledo e Souza.",

  LOADING_WAITING: "Loading information, please wait.",
  WLAN_INFO: "WLAN Information",
  MAC: "MAC",
  DNS: "DNS",

  ALTER_MONITOR_HOSTNAME_CONFIRM_1: "Are you sure you want to change the hostname?",
  ALTER_MONITOR_HOSTNAME_CONFIRM_2: "The monitor must be restarted for this.",
  HOSTNAME_POPUP_1: "A hostname must contain between 2 and 64 characters to be valid.",
  HOSTNAME_POPUP_2: "In addition, it may contain only letters, numbers, dots, and hyphens, and must start and end only with letters and numbers.",
  INVALID_HOSTNAME_1: "The hostname must contain between 2 and 64 characters.",
  INVALID_HOSTNAME_2: "The hostname must contain only letters, numbers, dots, and hyphens, and must start and end only with letters and numbers.",
  HOSTNAME_CONFIG_SUCCESS: "The hostname was configured successfully.",
  HOSTNAME_CONFIG_ERROR: "An error occurred while configuring the hostname",
  MODE: "Mode",
  HIDDEN_SSID: "Hidden SSID",
  OPTIONAL: " (Optional)",

  // ---------------------------- Edit Tags page related ----------------------------
  ADD_ALTER_TAGS: "Add/Change Tags",
  CHOOSE_DEVICE: "Choose a device",
  NEW_TAG: "New TAG",
  SAVE: "Save",
  REMOVE_ALL_TAGS: "Remove all Tags",
  REMOVE: "Remove",
  CONFIRM_REMOVE_ALL_TAGS: "Are you sure you want to remove the tags from all devices?",
  CHANGE_TAG_SUCCESS: "The tag was changed successfully.",
  CHANGE_TAG_FAILURE: "An error occurred while changing the tag",
  REMOVE_TAG_SUCCESS: "The tags were removed successfully.",
  REMOVE_TAG_FAILURE: "An error occurred while removing the tags",
  IMPORT_TAGS_SUCCESS: "The tags were imported successfully",
  IMPORT_TAGS_FAILURE: "An error occurred while importing the tags: ",
  PLEASE_SELECT_TAG_FILE: "Please select a tag file.",
  IMPORT_TAGS: "Import tags",
  EXPORT_TAGS: "Export tags",

  MASTER_HASH: "Master #",
  SLAVE_HASH: "Slave #",

  // ---------------------------- Edit GSD page related ----------------------------
  REMOVE_GSD_SUCCESS: "The GSD files were removed successfully",
  REMOVE_GSD_FILES: "Manage GSD files",
  SELECT_AT_LEAST_ONE_FILE_TO_DELETE: "Please select at least one file to remove",
  REMOVING_GSD_FILES: "Removing GSD files",
  FILTER_GSD_FILES: "Filter GSD files",

  SELECT_ALL: "Select all",
  REMOVE_SELECTED: "Remove selected",

  // ---------------------------- Blacklist page related ----------------------------
  ADD_DEVICES_TO_BLACKLIST_FAILURE: "An error occurred while adding the slaves to the blacklist.",

  REMOVE_DEVICES_FROM_BLACKLIST_FAILURE: "An error occurred while removing the slaves from the blacklist.",

  REMOVE_CRITIC_DEVICES_FROM_BLACKLIST_FAILURE: "An error occurred while removing the slaves from the critical slave list.",

  BLACKLIST_FORM_INPUT_PLACEHOLDER: "Filter devices by address, tag, or model",
  BLACKLIST_ADDRESS: "Address",
  BLACKLIST_TAG: "Tag",
  BLACKLIST_MODEL: "Model",
  BLACKLIST_CRITICAL_SLAVE: "Critical slave",
  UPDATE_BLACKLIST: "Update blacklist",
  UPDATING_BLACKLIST_DATA: "Updating information, please wait",

  BLACKLIST_HEADER_CELL_POPUP: "Prevents logging of a specific device so as not to generate repetitive or unwanted events.",
  BLACKLIST_HEADER_CELL_POPUP_2: "A slave on the Blacklist does not change the network status on the Summary tab. Its faults, retries, and diagnostics are still counted.",

  AUTOMATIC_BLACKLIST_HEADER_CELL_POPUP: "Slaves that present a high number of events are automatically added to the critical slave list. Their events are no longer saved to avoid saturating the log, but their faults, retries, and diagnostics are still counted.",
  AUTOMATIC_BLACKLIST_HEADER_CELL_POPUP_2: "The user can remove critical slaves, but cannot add them.",
  AUTOMATIC_BLACKLIST_HEADER_CELL_POPUP_3: "If there is at least one critical slave in the list, it changes the network status to CRITICAL SLAVE on the Summary tab.",

  ADD_BLACKLIST_CONFIRM_TEXT: "Are you sure you want to apply the changes to the blacklist and the critical slaves list?",

  // ---------------------------- PDF Report ----------------------------
  PROFIBUS: "PROFIBUS",

  REPORT_EXPORT_NAME: "TS Monitor PROFIBUS PRO Report",
  HEADER_TEXT: "Data report - TS Monitor PROFIBUS PRO - Protocol",

  GENERATING_REPORT_WAITING: "Generating report, please wait",
  GENERATING_REPORT_SUCCESS: "Report generated successfully. To save it, click save report below.",

  CONFORMITY: "Conformity",
  DROPDOWN_PLACEHOLDER: "Choose an option",
  GENERATE_REPORT: "Generate report",

  GENERAL_REPORT: "General report – TS Monitor PROFIBUS PRO",
  DATA_REPORT: "Data report – TS Monitor PROFIBUS PRO",

  MONITORING_INFO: "Monitoring information",
  ETHERNET_INFO: "ETHERNET information",

  IP_DP: "- IP: ",
  MASK_DP: "- Subnet mask: ",
  GATEWAY_DP: "- Gateway: ",

  CLIENT_INFO: "Client information",
  EXECUTING_COMPANY_INFO: "Contractor company information",
  ANNOTATIONS: "Notes",
  CONCLUSION: "Conclusion",

  CONFORM_STRING: "Compliant",
  CONFORM_W_RESTRICTION_STRING: "Compliant with restrictions",
  NON_CONFORM_STRING: "Non-compliant",

  PROJECT_NAME: "- Project name:",
  NETWORK_NAME: "- Network name:",
  LOCATION: "- Location:",
  COMPANY_NAME: "- Company name:",
  ACCOUNTABLE_NAME: "- Responsible person:",
  COMPANY_ADDRESS: "- Address:",
  COMPANY_CITY: "- City:",
  COMPANY_TEL: "- Phone:",

  EXECUTING_COMPANY_NAME: "- Company name:",
  EXECUTING_ACCOUNTABLE_NAME: "- Responsible person:",
  EXECUTING_TEL: "- Phone:",
  EXECUTING_EMAIL: "- Email:",

  NETWORK_NAME_DP: "- Network name: ",
  TAG_NAME_DP: "- Network tag: ",
  MONITOR_VERSION_DP: "- Monitor version: ",
  MONITOR_INIT_DP: "- Monitoring start: ",
  GENERATING_TIME_DP: "- Report generation: ",
  DURATION_SINCE_MON_BEGIN: "- Monitoring duration until report generation: ",

  TS_MONITOR_VER_DP: "TS Monitor PROFIBUS PRO - Version ",
  NETWORK_AVAILABILITY_DP: "Network availability: ",
  BAUD_RATE_DP: "Baud rate: ",
  CYCLE_TIME_DP: "Cycle time: ",
  DEVICE_DATA: "Device data",
  MASTERS_DP: "Masters: ",
  SLAVES_DP: "Slaves: ",
  ONLINE_SLAVES_DP: "Online slaves: ",
  MISSING_DP: "Missing: ",
  RETRIES_DP: "Retries: ",
  DIAGNOSTIC_DP: "Diagnostics: ",
  FAULT_DP: "Faults: ",
  WATCHDOG_DP: "Watchdog: ",
  RETRIES_LIMIT_DP: "Retry limit: ",
  HSA_DP: "HSA: ",

  SUMMARY: "Summary",
  RESUME: "Summary",
  LIVE_LIST: "Live List",
  LOG: "Log",
  MATRIX: "Matrix",
  GRAPHIC_TOPOLOGY: "Graphic topology",
  CONFIG_STRING: "Settings",

  RESUME_DOTS: "....................................................................................................................................",
  LIVE_LIST_DOTS: ".......................................................................................................................................",
  MON_LOG_DOTS: "...............................................................................................................................................",
  DISCLAIMER_DOTS: "..........................................................................................................................",

  M_MONITORING_RESUME_PAGE_TITLE: "1.1. - Summary",
  M_MONITORING_LIVE_LIST_PAGE_TITLE: "1.2. Live List",
  M_MONITORING_LOG_PAGE_TITLE: "1.3. - Log",

  ADDRESS: "Address",
  MODEL: "Model",

  LAST_200_EVENTS: "Last 200 events",
  HORARY: "Time",
  DESCRIPTION: "Description",

  END_OF_REPORT: "End of report",
  DISCLAIMER: "Legal disclaimer",
  DISCLAIMER_TEXT: "The data and values presented in this report are merely auxiliary to the PROFIBUS specialist, so any indication of correction must be made by the user. For this reason, it is recommended that a certified PROFIBUS engineer or a technician responsible for the analysis accompany the process in order to validate the information provided by the product. Therefore, Toledo & Souza disclaims any liability, losses, or damages, direct or indirect, caused by interpretations of the software, and offers no warranty regarding the integrity, quality, or suitability of the provided information, as it depends on the technical analysis of a qualified professional. In the absence of such a professional, the user assumes the risk that the content may be inaccurate, incomplete, or may not meet their needs and requirements.",

  DIAGNOSTIC_STRING: "Diagnostic",
  ONLINE_STRING: "Online",
  MISSING_PLURAL_STRING: "Missing",
  MISSING_SINGULAR_STRING: "Missing",
  CONFIG_ERROR_STRING: "Configuration error",
  PARAM_ERROR_STRING: "Parameterization error",
  FAULT_STRING: "Fault",
  BLACKLIST_STRING: "Blacklist",
  CRITIC_SLAVE_STRING: "Critical slave",
  MASTER_FAULT_STRING: "Master",
  SLAVE_MASTER_FAULT_STRING: "Master in fault",
  MPI_STRING: "MPI",
  MPI_CSV_FAULT_STRING: "MPI in fault",
  MASTER_CLASS_2: "Master",
  MASTER_OPERATE: "Master - operate",
  MASTER_SYNC: "Master - sync",
  MASTER_UNSYNC: "Master - unsync",
  MASTER_FREEZE: "Master - freeze",
  MASTER_UNFREEZE: "Master - unfreeze",
  MASTER_CLEAR: "Master - clear",
  CLASS_2: "",
  MASTER_OPERATE_CAPITAL: "Master - Operate",
  MASTER_SYNC_CAPITAL: "Master - Sync",
  MASTER_UNSYNC_CAPITAL: "Master - Unsync",
  MASTER_FREEZE_CAPITAL: "Master - Freeze",
  MASTER_UNFREEZE_CAPITAL: "Master - Unfreeze",
  MASTER_CLEAR_CAPITAL: "Master - Clear",

  // ---------------------------- OTHERS ----------------------------
  BEFORE_MONITOR_INIT_STR: "Before the last initialization",
  REMOVE_DEVICE_SUCCESS: "The device will be removed within 30 seconds.",
  REMOVE_DEVICE_FAILURE: "An error occurred while removing the device: ",

  OK_STRING: "OK",
  WITH_DIAGNOSTIC_STRING: "The network has slaves in diagnostic state",
  WITH_FAILURE_STRING: "The network has slaves in fault state",
  WITH_CRITICAL_SLAVE_STRING: "The network has slaves in critical state",
  WITH_MASTER_FAULT_STRING: "The network has masters in fault state",
  UNKNOWN: "Unknown",
  LOG_WAITING: "Loading log data",
  LIVE_LIST_INPUT_TEXT_PLACEHOLDER: "Filter by address or status",
  LOG_INPUT_TEXT_PLACEHOLDER: "Filter by address, tag, model, or \"Network event\"",
  OPTIC_FIBER_LOG_INPUT_TEXT_PLACEHOLDER: "Filter by event type",
  OPTIC_FIBER_INSERT_VALID_TYPE: "Please enter a valid event type.",
  SLAVE_DIAGNOSTIC: "Slave diagnostic:",
  STATUS_CHANGE: "Status change: ",
  NETWORK_EVENT: "Network event",
  MASTER_HASHTAG: "Master #",
  CONFIG_ERROR_1: "Configuration",
  CONFIG_ERROR_2: "error",
  PARAM_ERROR_1: "Parameterization",
  PARAM_ERROR_2: "error",
  LAST_EVENT: "Last event: ",
  MODEL_: "Model: ",

  DIAGNOSTICS_STRING: "Diagnostics",
  RETRIES_STRING: "Retries",
  NO_FAULTS_STRING: "without faults",
  TOTAL: "total",
  RETRIES_NO_FAULT_STRING: "Retries without faults",
  FAULTS_STRING: "Faults",
  WATCHDOG_STRING: "Watchdog",
  BILLION_OF: "Billion of",
  BILLIONS_OF: "Billions of",
  MILLION_OF: "Million of",
  MILLIONS_OF: "Millions of",
  THOUSAND: "Thousand",
  LAST_EVENT_TOO_BIG_STRING: "Description too long, please consult the log.",
  CRITICAL_SLAVE_EXPLANATION: "TS Monitor has an automatic function to select slaves that have an excessive number of events and informs the user that this device is critical to the PROFIBUS network.",
  DIAGNOSTICS_QUESTION_INFO: " Indicates the number of diagnostics detected on the PROFIBUS network. Diagnostics indicate abnormal device status conditions, such as short circuit, power supply problems, missing module, etc.",
  RETRIES_QUESTION_INFO: "Indicates the number of times the master had to resend a message to a given device after not receiving a response. Usually indicates physical layer problems.",
  NOT_RETRIES_QUESTION_INFO: "Retries without faults help us identify network problems that have not yet caused the device to drop. It also disregards drops caused by shutdown or disconnection.",

  FAULTS_QUESTION_INFO: "Indicates the number of times a given PROFIBUS device stopped responding to master messages.",

  WATCHDOG_QUESTION_INFO_1: "The watchdog is the time the slave waits after losing communication with the master before changing its outputs to the safe condition.",
  WATCHDOG_QUESTION_INFO_2: "This parameter is sent by the master individually to all slaves on the network in their respective parameterization telegram.",
  WATCHDOG_QUESTION_INFO_3: "If the cycle time is close to the watchdog, the network becomes more vulnerable.",
  WATCHDOG_QUESTION_INFO: "Indicates whether the watchdog for the device is active, inactive, or has not yet been parameterized.",

  // ---------------------------- GRAPHIC TOPOLOGY ----------------------------
  GRAPHIC_TOPOLOGY_INPUT_PLACEHOLDER: "Search device by address or tag",

  EDIT_TOPOLOGY_POS_STRING: "Edit",
  EDIT_EDGE_TYPE: "Edit connection type",
  SAVE_TOPOLOGY_POS_STRING: "Save",
  DELETE_TOPOLOGY_POS_STRING: "Remove",
  EXPORT_SVG: "SVG",

  EXPORT_TOPOLOGY: "Topology",
  IMPORT: "Import",
  IMPORT_TOPOLOGY: "Import Topology",
  POSITION: "Position",
  EXPORT: "Export",

  SAVE_TOPOLOGY_POS_SUCCESS_STRING: "Topology positioning was saved successfully!",
  SAVE_TOPOLOGY_POS_FAILURE_STRING: "The following error occurred while saving topology positioning: ",

  DROP_TOPOLOGY_POS_SUCCESS_STRING: "Topology positioning was removed successfully!",
  DROP_TOPOLOGY_POS_FAILURE_STRING: "The following error occurred while removing topology positioning: ",

  ASK_REMOVE_POSITIONING: "Are you sure you want to remove the saved positioning?",
  REMOVE_POSITIONING: "Remove positioning",

  YES: "Yes",
  NO: "No",

  ALERT_NOT_POSSIBLE_TO_EDIT: "It is not possible to edit master data",
  ALERT_NOT_POSSIBLE_TO_EDIT_SCOPE: "It is not possible to edit TS Scope data",
  ALERT_NOT_POSSIBLE_TO_DELETE: "It is not possible to remove a device from the live list",
  ALERT_CHOOSE_DEVICE_TYPE: "Please choose a device type",
  ALERT_CHOOSE_CONNECTION_TYPE: "Please select a connection type",

  ADD_DEVICE: "Add device",
  TAG_PLACEHOLDER: "TAG (optional)",

  DEVICE_DEFAULT_DROPDOWN_PLACEHOLDER: "Choose a device type",
  ADD_CONNECTION: "Add connection",
  CONNECTION_DEFAULT_DROPDOWN_PLACEHOLDER: "Choose a connection type",
  EDIT_DEVICE: "Edit device",

  CANCEL: "Cancel",
  ADD: "Add",

  MASTER_NAME: "Master",
  SLAVE_NAME: "Slave",
  SLAVE_PA_NAME: "PA Slave",
  REPEATER_NAME: "Repeater",
  HUB_NAME: "Hub",
  JB_NAME: "Junction Box",
  COUPLER_PROXY_NAME: "Coupler/Proxy",
  FIBER_LINK_NAME: "Fiber link",
  ACTIVE_TERMINATION_NAME: "Active terminator",
  UNKNOWN_NAME: "Unknown",
  TS_MONITOR_NAME: "TS Monitor",
  TS_MONITOR_PRO_NAME: "TS Monitor PRO",
  MPI_NAME: "MPI",
  TS_SCOPE_DP_NAME: "TS Scope DP",
  TS_SCOPE_PA_NAME: "TS Scope PA",

  LOCALE_EDIT: "Edit",
  LOCALE_DEL: "Remove selected",
  LOCALE_BACK: "Back",
  LOCALE_ADD_NODE: "Add device",
  LOCALE_ADD_EDGE: "Add connection",
  LOCALE_EDIT_NODE: "Edit device",
  LOCALE_EDIT_EDGE: "Edit connection",
  LOCALE_ADD_DESCRIPTION: "Click on an empty space to add a new device",
  LOCALE_EDGE_DESCRIPTION: "Click on a device and drag the connection to another device to connect them",
  LOCALE_EDIT_EDGE_DESCRIPTION: "Click the control points and drag them to a device to connect them",
  LOCALE_CREATE_EDGE_ERROR: "It is not possible to create a connection for a cluster",
  LOCALE_DELETE_CLUSTER_ERROR: "Clusters cannot be removed",
  LOCALE_EDIT_CLUSTER_ERROR: "Clusters cannot be edited",

  FORM_NO_DEVICE_FOUND_PREFIX: "The device with address ",
  FORM_NO_DEVICE_FOUND_SUFFIX: " was not found",

  INSERT_VALID_ADDRESS_OR_TAG: "Please enter a valid address or tag",
  INSERT_VALID_ADDRESS0_TAG_OR_MODEL: "Please enter a valid address, tag, or model",

  POSITIONING_CONFLICT_1: "There is a conflict in the information of devices with addresses:",
  POSITIONING_CONFLICT_2: "\nAs a result, their positions and connections will return to the default state.",
  POSITIONING_ANG_CONNECTIONS_RESET_SUCCESS: "Positions and connections successfully returned to the default state",
  POSITIONING_ANG_CONNECTIONS_RESET_FAILURE: "The following error occurred while returning positions and connections to the default state: ",

  TOPOLOGY_IMPORT_SUCCESS: "The topology was imported successfully!",
  ERROR_IMPORTING_GRAPHIC_TOPOLOGY: "An error occurred while importing the graphic topology: ",
  INVALID_OR_CORRUPT_FILE: "The file is invalid or corrupted.",
  PLEASE_SELECT_TOPOLOGY_FILE: "Please select a topology file.",

  COLORS_LABELS: "Color legend",
  LABEL_SLAVE_OK_MASTER_OP: ": Slave OK, and master in operate;",
  LABEL_MASTER_STOP_CLEAR: ": Master in STOP / CLEAR;",
  LABEL_SLAVE_DIAG: ": Slave in diagnostic;",
  LABEL_SLAVE_N_MASTER_FAULT: ": Slave in fault, and master in fault;",
  LABEL_SLAVE_CONFIG_ERROR: ": Slave with configuration error;",
  LABEL_SLAVE_PARAM_ERROR: ": Slave with parameterization error;",
  LABEL_SLAVE_ONLINE: ": Slave online;",
  LABEL_SLAVE_MISSING: ": Slave missing;",
  LABEL_SLAVE_MASTER_FAULT: ": Slave with master in fault;",
  LABEL_SLAVE_BLACKLIST: ": Slave in blacklist;",
  LABEL_CRITICAL_SLAVE: ": Critical slave;",
  LABEL_MPI: ": MPI;",
  LABEL_NO_STATUS: ": Device without status.",

  DEVICE_TAG_NOT_FOUND: "No device with TAG was found: ",

  INSERT_VALID_ADDRESS_1_127: "Enter a valid slave address, between 1 and 127.",
  DEVICE_WITH_ADDRESS: "The device with address ",
  WAS_SUCCESSFULLY_ADDED: " was added successfully.",
  WAS_SUCCESSFULLY_REMOVED: " was removed successfully.",
  IS_ALREADY_IN_NETWORK: " is already on the network.",
  REMOVE_DEVICE_ERROR: "The following error occurred while trying to remove the device: ",

  TS_SCOPE_NOT_FOUND: "Could not find TS Scope with IP:",
  INVALID_INSERTED_IP: "The entered IP is invalid",
  TS_SCOPE_FETCH_SUCCESS: "TS Scope fetch was successful",

  // ---------------------------- TS EXPERT CONFIG ----------------------------
  TS_EXPERT: "TS Expert",
  SETUP: "Setup",

  TS_EXPERT_CONFIGURATION: "TS Expert settings",
  SENDING_TS_EXPERT_CONFIG_WAITING: "Updating TS Expert settings, please wait a moment.",
  TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY: "TS Expert settings were saved successfully.",
  TS_EXPERT_CONFIG_SAVE_ERROR: "An error occurred while saving TS Expert settings.",

  CONFIG_RETRIES_LIST_HEADER: "Retries without fault",
  CONFIG_RETRIES_LIST_CONTENT: "When this option is enabled, TS Expert will indicate retries that did not lead to a fault, by device. Retries without fault help identify network problems that have not yet caused the device to drop. It also disregards drops caused by shutdown or disconnection.",

  CONFIG_DIAGNOSTIC_LIST_HEADER: "Diagnostics",
  CONFIG_DIAGNOSTIC_LIST_CONTENT: "When this option is enabled, TS Expert will indicate all diagnostics, by device.",

  CONFIG_FAULT_LIST_HEADER: "Faults",
  CONFIG_FAULT_LIST_CONTENT: "When this option is enabled, TS Expert will indicate all faults, by device.",

  CONFIG_FAULT_SEQUENCE_LIST_HEADER: "Fault sequence",
  CONFIG_FAULT_SEQUENCE_LIST_CONTENT: "When this option is enabled, TS Expert will record all faults that occur in sequence in case of faults in several devices.",

  CONFIG_CONFIG_ERROR_LIST_HEADER: "Configuration error",
  CONFIG_CONFIG_ERROR_LIST_CONTENT: "When this option is enabled, TS Expert will indicate all devices that present a configuration error.",

  CONFIG_PARAM_ERROR_LIST_HEADER: "Parameterization error",
  CONFIG_PARAM_ERROR_LIST_CONTENT: "When this option is enabled, TS Expert will indicate all devices that present a parameterization error.",

  CONFIG_MISSING_LIST_HEADER: "Missing slave",
  CONFIG_MISSING_LIST_CONTENT: "When this option is enabled, TS Expert will indicate all missing slaves.",

  CONFIG_ONLINE_LIST_HEADER: "Online slave",
  CONFIG_ONLINE_LIST_CONTENT: "When this option is enabled, TS Expert will indicate all online slaves.",

  CONFIG_CRITICAL_SLAVE_LIST_HEADER: "Critical slave",
  CONFIG_CRITICAL_SLAVE_LIST_CONTENT: "When this option is enabled, TS Expert will record all critical slaves.",

  CONFIG_MASTER_FAULT_LIST_HEADER: "Master in fault",
  CONFIG_MASTER_FAULT_LIST_CONTENT: "When this option is enabled, TS Expert will indicate when TS Monitor is not receiving PROFIBUS frames.",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_HEADER: "Optic fiber link – Voltage level failure (Action Required)",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_CONTENT: "When this option is enabled, TS Expert will indicate low voltage at the analog outputs that indicate the quality of the signal received by the fiber link. This value can be configured by the user on the TS Scope/Monitor PRO settings screen.",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_HEADER: "Optic fiber link – Voltage level failure (Urgent Action)",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_CONTENT: "When this option is enabled, TS Expert will indicate low voltage at the analog outputs that indicate the quality of the signal received by the fiber link. This value can be configured by the user on the TS Scope/Monitor PRO settings screen.",

  FIBER_SIGNAL_LOSS_LIST_HEADER: "Optic fiber link – Relay failure",
  FIBER_SIGNAL_LOSS_LIST_CONTENT: "When this option is enabled, TS Expert will show a fiber link failure indicated by relay, which must be connected to the TS Scope/Monitor PRO.",

  // ---------------------------- TS EXPERT ----------------------------
  TS_EXPERT_REPORT_EXPORT_NAME: "Action list - TS Expert - Monitor PROFIBUS PRO",

  TS_EXPERT_POPUP_1: "This tab presents TS Expert information.",
  TS_EXPERT_POPUP_2: "This tool is an expert system developed to optimize and speed up the analysis of the main discrepancies detected by TS Monitor in PROFIBUS networks.",
  TS_EXPERT_POPUP_3: "Automatically, maintenance, engineering, and related teams can obtain an action list with different events, their possible causes, solution suggestions, and the devices in which they were detected.",
  TS_EXPERT_POPUP_4: "The use of TS Expert does not exclude the need for human analysis and does not replace the ability to correlate and interpret data.",

  DETECTED_ON: "Detected on: ",
  CHECK_YOUR_NETWORK: "Please check your network.",

  EXPORT_ACTIONS_LIST: "Export action list",
  GENERATING_ACTIONS_LIST_WAITING: "Generating action list PDF, please wait.",
  GENERATING_ACTIONS_LIST_SUCCESS: "PDF generated successfully. To save it, click save action list.",

  EVENTS_LIST: "Event list",
  ACTIONS: "Actions",

  NO_PROBLEM_DETECTED: "TS Expert detected no events on the network.",
  NO_EVENTS_TO_BE_ANALYZED: "There are no events to be analyzed.",

  NO_EVENT_SELECTED: "No event selected",
  CHOOSE_AN_EVENT: "Choose an event to view the suggested actions.",

  DETAILING: "Details",

  CHECKED: "Checked",
  BATCH_CHECK: "Check all",

  PROBLEM_CHECKED: "The event was checked successfully",
  PROBLEM_CHECK_ERROR: "An error occurred while checking the event.",

  LAST_UPDATED: "Last updated on: ",
  THIS_COMPUTER_TIME: " (This computer's time)",

  DEVICE: "Device",

  // ---------------------------- RETRIES (TS EXPERT) ----------------------------
  RETRIES_LIST_HEADER: "There are devices on the network that have retries without faults.",
  DEVICE_WITH_RETRIES: "Device with retries without faults",

  RETRIES_INITIAL_ERROR_MSG: "Could not check the events of the following devices because they still have retries:\n",
  S_RETRIES_INITIAL_ERROR_MSG: "Could not check the device event because it still has retries\n",

  RETRIES_SUGGESTION_1: "When a device has retries without faults, the following is suggested:",
  RETRIES_SUGGESTION_2: "Retries without faults indicate the number of times the master had to resend a message to a given device after not receiving a response, either because the slave did not respond or because the response was corrupted (illegal or incomplete frame), due to noise, low insulation in the slave, or in the bus infrastructure. Retries without faults help identify network problems that have not yet caused the device to drop. It also disregards drops caused by shutdown or disconnection.",
  RETRIES_SUGGESTION_3: "Check and correct connector assembly. The TDC-1000 can help with this task;",
  RETRIES_SUGGESTION_4: "Check for damage to the PROFIBUS cable, such as:",
  RETRIES_SUGGESTION_5: "Bends smaller than 10 times the conductor radius;",
  RETRIES_SUGGESTION_6: "Cuts in the cable;",
  RETRIES_SUGGESTION_7: "Twists in the cable;",
  RETRIES_SUGGESTION_8: "Crushed cable sections.",
  RETRIES_SUGGESTION_9: "These non-conformities require replacing the cable section (it is not possible to solve the non-conformity by straightening or uncrushing the cable);",
  RETRIES_SUGGESTION_10: "Check whether there are power cables close to PROFIBUS cables. Data cables such as PROFIBUS should be kept as far apart as possible or placed in closed and grounded cable trays/conduits, following the minimum indicated by the guidelines according to the electrical conductor classification, EN50174 standard;",
  RETRIES_SUGGESTION_11: "Measure leakage current in the cable with an appropriate clamp meter; if the measured value is greater than 100mA, it is necessary to check equipotential bonding and the grounding system;",
  RETRIES_SUGGESTION_12: "Check signal quality with one of Toledo e Souza's devices equipped with an oscilloscope, which will provide tips according to the measurements performed;",
  RETRIES_SUGGESTION_13: "If none of the above solves the problem, and a specific device is showing retries in isolation (only one specific slave shows retries), it is suggested to replace the slave's network interface.",
  RETRIES_SUGGESTION_14: "The only item that may achieve better results while the plant is running is item “d”; however, using Toledo e Souza equipment with an oscilloscope must be done with caution, because if the signal condition is very compromised it may bring the network down.",

  // ---------------------------- DIAGNOSTIC (TS EXPERT) ----------------------------
  DIAGNOSTIC_LIST_HEADER: "There are devices on the network that have diagnostics.",
  DEVICE_WITH_DIAGNOSTIC: "Device with diagnostics",

  DIAGNOSTIC_INITIAL_ERROR_MSG: "Could not check the events of the following devices because they still have diagnostics:\n",
  S_DIAGNOSTIC_INITIAL_ERROR_MSG: "Could not check the device event because it still has diagnostics\n",

  DIAGNOSTIC_SUGGESTION_1: "When a device has diagnostics, the following is suggested:",
  DIAGNOSTIC_SUGGESTION_2: "The “Diagnostic” state is information sent by the slave to the master. It is usually not a network problem, but rather a warning from the slave that it needs maintenance or replacement. Below is the list of actions to solve the problem:",
  DIAGNOSTIC_SUGGESTION_3: "If a slave shows diagnostics, check the information sent and try to solve the problem. If you have difficulty understanding the diagnostic, contact the slave manufacturer to clarify your doubts before intervening;",
  DIAGNOSTIC_SUGGESTION_4: "A growing number of diagnostics without maintenance data may be directly linked to device faults, because when the equipment communicates again there is a confirmation diagnostic that checks whether the slave is ready for data exchange. Check whether the number of diagnostics is close to the number of faults; in this case, follow the fault testing step-by-step.",

  // ---------------------------- FAULT (TS EXPERT) ----------------------------
  FAULT_LIST_HEADER: "There are devices on the network that have faults.",
  DEVICE_WITH_FAULT: "Device with faults",

  FAULT_INITIAL_ERROR_MSG: "Could not check the events of the following devices because they still have faults:\n",
  S_FAULT_INITIAL_ERROR_MSG: "Could not check the device event because it still has faults\n",

  FAULT_SUGGESTION_1: "When a device has faults, the following is suggested:",
  FAULT_SUGGESTION_2: "The “Fault” state indicates that the slave stopped communicating, that is, it stopped exchanging data with the master (it dropped off the network). In this case it is not possible to determine the cause of the fault, which may be, for example, a cable break or lack of electrical power:",
  FAULT_SUGGESTION_3: "Check the slave power supply;",
  FAULT_SUGGESTION_4: "Check whether it is connected to the network (cable or fiber optic);",
  FAULT_SUGGESTION_5: "Check the integrity and correct assembly of the connector;",
  FAULT_SUGGESTION_6: "Check cable integrity;",

  // ---------------------------- FAULT SEQUENCE (TS EXPERT) ----------------------------
  FAULT_SEQ_LIST_HEADER: "There are devices on the network that have fault sequences.",
  DEVICE_WITH_FAULT_SEQ: "Device with fault sequence",

  FAULT_SEQ_INITIAL_ERROR_MSG: "Could not check the events of the following devices because they still have an error sequence:\n",
  S_FAULT_SEQ_INITIAL_ERROR_MSG: "Could not check the device event because it still has an error sequence\n",

  FAULTS_SEQ_SUGGESTION_1: "In the case of a sequence of device faults, the following is suggested:",
  FAULTS_SEQ_SUGGESTION_2: "Check the power supply of the slaves that stopped communicating;",
  FAULTS_SEQ_SUGGESTION_3: "Check the signal quality in the segment of the first slave that stopped communicating using one of Toledo e Souza's devices equipped with an oscilloscope;",
  FAULTS_SEQ_SUGGESTION_4: "Check whether they are connected to the network;",
  FAULTS_SEQ_SUGGESTION_5: "Check whether any isolating terminator was switched on accidentally;",
  FAULTS_SEQ_SUGGESTION_6: "Check the network terminators of this segment;",
  FAULTS_SEQ_SUGGESTION_7: "Check the integrity of the bus in this segment;",
  FAULTS_SEQ_SUGGESTION_8: "Check for potential failures in repeaters, hubs, or fiber optic links.",

  // ---------------------------- CONFIG ERROR (TS EXPERT) ----------------------------
  CONFIG_ERROR_LIST_HEADER: "There are devices on the network with a configuration error.",
  DEVICE_WITH_CONFIG_ERROR: "Device with configuration error",

  CONFIG_ERROR_INITIAL_ERROR_MSG: "Could not check the events of the following devices because they still have a configuration error:\n",
  S_CONFIG_ERROR_INITIAL_ERROR_MSG: "Could not check the device event because it still has a configuration error\n",

  CONFIG_ERROR_SUGGESTION_1: "When a device has a configuration error, the following is suggested:",
  CONFIG_ERROR_SUGGESTION_2: "This occurs when a slave did not accept the configuration made in the master or SDCD and did not enter data exchange. Suggestion:",
  CONFIG_ERROR_SUGGESTION_3: "Check the configuration in the master or SDCD software;",

  // ---------------------------- PARAM ERROR (TS EXPERT) ----------------------------
  PARAM_ERROR_LIST_HEADER: "There are devices on the network with a parameterization error.",
  DEVICE_WITH_PARAM_ERROR: "Device with parameterization error",

  PARAM_ERROR_INITIAL_ERROR_MSG: "Could not check the events of the following devices because they still have a parameterization error:\n",
  S_PARAM_ERROR_INITIAL_ERROR_MSG: "Could not check the following device event because it still has a parameterization error\n",

  PARAM_ERROR_SUGGESTION_1: "When a device has a parameterization error, the following is suggested:",
  PARAM_ERROR_SUGGESTION_2: "This occurs when a slave did not accept the parameterization made in the master or SDCD and did not enter data exchange. Parameterization is a check of the slave ID Number, that is, it may be that a different slave from the one declared in the system was installed. Suggestion:",
  PARAM_ERROR_SUGGESTION_3: "Check whether the slave declared in the master or SDCD software is the same as the one installed in the field.",

  // ---------------------------- MISSING (TS EXPERT) ----------------------------
  MISSING_LIST_HEADER: "There are missing devices on the network.",
  DEVICE_MISSING: "Missing device",

  MISSING_INITIAL_ERROR_MSG: "Could not check the events of the following devices because they are still missing:\n",
  S_MISSING_INITIAL_ERROR_MSG: "Could not check the device event because it is still missing\n",

  MISSING_SUGGESTION_1: "When a device is missing, the following is suggested:",
  MISSING_SUGGESTION_2: "This occurs when the master or SDCD is searching for a slave on the network but receives no response. This slave was configured in the project but is not responding on the network or is not installed. Suggestion:",
  MISSING_SUGGESTION_3: "Check whether the slave declared in the master or SDCD software is connected to the network and powered.",
  MISSING_SUGGESTION_4: "It is not recommended to leave the master or SDCD searching for slaves that will not be installed.",

  // ---------------------------- ONLINE (TS EXPERT) ----------------------------
  ONLINE_LIST_HEADER: "There are online devices on the network.",
  DEVICE_ONLINE: "Online device",

  ONLINE_INITIAL_ERROR_MSG: "Could not check the events of the following devices because they are still online:\n",
  S_ONLINE_INITIAL_ERROR_MSG: "Could not check the device events because it is still online\n",

  ONLINE_SUGGESTION_1: "When a device is online, the following is suggested:",
  ONLINE_SUGGESTION_2: "This occurs when the master or SDCD finds a slave on the network, but it is not configured in the system. Suggestion:",
  ONLINE_SUGGESTION_3: "Check whether the slave should be off the network or whether it must be configured.",

  // ---------------------------- CRITICAL SLAVE (TS EXPERT) ----------------------------
  CRITICAL_SLAVE_LIST_HEADER: "There are critical slaves on the network.",
  DEVICE_IS_CRITICAL_SLAVE: "Device is a critical slave",

  CRITICAL_SLAVE_INITIAL_ERROR_MSG: "Could not check the events of the following devices because they are still critical slaves:\n",
  S_CRITICAL_SLAVE_INITIAL_ERROR_MSG: "Could not check the device event because it is still a critical slave\n",

  CRITICAL_SLAVE_SUGGESTION_1: "When there are critical slaves on the network, the following is suggested:",
  CRITICAL_SLAVE_SUGGESTION_2: "TS Monitor has an automatic function to select slaves that have an excessive number of events and informs the user that this device is critical to the PROFIBUS network. Suggestion:",
  CRITICAL_SLAVE_SUGGESTION_3: "Check the slave installation condition;",
  CRITICAL_SLAVE_SUGGESTION_4: "Check the slave power supply;",
  CRITICAL_SLAVE_SUGGESTION_5: "Check whether it is properly connected to the network;",
  CRITICAL_SLAVE_SUGGESTION_6: "Check the integrity and correct assembly of the connector;",
  CRITICAL_SLAVE_SUGGESTION_7: "Check cable integrity;",
  CRITICAL_SLAVE_SUGGESTION_8: "Check the signal quality condition of the slave with one of Toledo e Souza's devices equipped with an oscilloscope;",
  CRITICAL_SLAVE_SUGGESTION_9: "If analysis with the oscilloscope-equipped device does not solve the issue, it is suggested to replace the network interface.",
  CRITICAL_SLAVE_SUGGESTION_10: "To remove the slave from this state, go to settings, then blacklist, and uncheck the checkbox.",

  // ---------------------------- MASTER FAULT (TS EXPERT) ----------------------------
  MASTER_FAULT_LIST_HEADER: "There are masters in fault on the network.",
  DEVICE_IS_MASTER_FAULT: "Device is a master in fault",

  MASTER_FAULT_INITIAL_ERROR_MSG: "Could not check the events of the following devices because they are not receiving PROFIBUS frames:\n",
  S_MASTER_FAULT_INITIAL_ERROR_MSG: "Could not check the device event because it is not receiving PROFIBUS frames\n",

  MASTER_FAULT_SUGGESTION_1: "When there are masters in fault on the network, the following is suggested:",
  MASTER_FAULT_SUGGESTION_2: "This occurs when TS Monitor PROFIBUS PRO stops reading the network. Suggestion:",
  MASTER_FAULT_SUGGESTION_3: "Check whether there was a general network failure;",
  MASTER_FAULT_SUGGESTION_4: "Check whether TS Monitor was isolated from the network;",
  MASTER_FAULT_SUGGESTION_5: "Check whether TS Monitor is properly connected to the PROFIBUS network.",

  VOLTAGE_: "Voltage",

  // ---------------------------- FIBER LOWER LIMIT MAINTENANCE REQUIRED ----------------------------
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_ERROR_MSG: "It was not possible to acknowledge the events because the fiber optic link still has a voltage level fault.",
  S_FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_INITIAL_ERROR_MSG: "It was not possible to acknowledge the event because the fiber optic link still has a voltage level fault.",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_1: "When an optic fiber link with voltage level failure is detected, the suggestion is to visually check:",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_2: "The fiber link power supply;",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_3: "Check the fiber and copper connections;",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_4: "Check the condition of the optical fibers.",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_5: "It is suggested to consult the fiber link manufacturer's manual to check the appropriate voltage level.",

  // ---------------------------- FIBER LOWER LIMIT URGENT MAINTENANCE ----------------------------
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_ERROR_MSG: "It was not possible to acknowledge the events because the fiber optic link still has a severe voltage level fault.",
  S_FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_INITIAL_ERROR_MSG: "It was not possible to acknowledge the event because the fiber optic link still has a severe voltage level fault.",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_1: "When a fiber optic link with a severe voltage-level fault is detected, it is suggested to visually check:",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_2: "The fiber link power supply;",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_3: "Check the fiber and copper connections;",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_4: "Check the condition of the optical fibers.",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_5: "It is suggested to consult the fiber link manufacturer's manual to check the appropriate voltage level.",

  // ---------------------------- FIBER SIGNAL LOSS ----------------------------
  FIBER_SIGNAL_LOSS_ERROR_MSG: "It was not possible to acknowledge the events because a fault signal is still being detected by the fiber optic link relay.",
  S_FIBER_SIGNAL_LOSS_INITIAL_ERROR_MSG: "It was not possible to acknowledge the event because a fault signal is still being detected by the fiber optic link relay.",

  FIBER_SIGNAL_LOSS_SUGGESTION_1: "When a relay fault signal is detected on the fiber optic link, it is suggested to visually check:",

  FIBER_SIGNAL_LOSS_SUGGESTION_2: "The fiber link power supply;",
  FIBER_SIGNAL_LOSS_SUGGESTION_3: "Check the fiber and copper connections;",
  FIBER_SIGNAL_LOSS_SUGGESTION_4: "Check the condition of the optical fibers.",

  // ---------------------------- EXPERT REPORT ---------------------------- 
  DEVICE_WITH_RETRIES_DOTS: "..............................................................................................",
  DEVICE_WITH_DIAGNOSTIC_DOTS: ".............................................................................................................",
  DEVICE_WITH_FAULT_DOTS: ".......................................................................................................................",
  DEVICE_WITH_CONFIG_ERROR_DOTS: "..................................................................................................",
  DEVICE_WITH_PARAM_ERROR_DOTS: "............................................................................................",
  DEVICE_MISSING_DOTS: ".............................................................................................................................",
  DEVICE_ONLINE_DOTS: "................................................................................................................................",
  DEVICE_IS_CRITICAL_SLAVE_DOTS: "...............................................................................................................",
  DEVICE_IS_MASTER_FAULT_DOTS: "............................................................................................................",
  DISCLAIMER_EXPERT_DOTS_1: "..........................................................................................................................",
  DISCLAIMER_EXPERT_DOTS_2: "............................................................................................................................",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_DOTS: ".........................................................",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_DOTS: ".............................................................",
  FIBER_SIGNAL_LOSS_DOTS: "....................................................................................................",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PAGE_TITLE: ". - Optic fiber link – Voltage level failure (Action Required)",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PAGE_TITLE: ". - Optic fiber link – Voltage level failure (Urgent Action)",
  FIBER_SIGNAL_LOSS_PAGE_TITLE: ". - Optic fiber link – Relay failure",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PAGE_DESCRIPTION: "TS Expert is indicating the presence of an optic fiber link with voltage level failure.",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PAGE_DESCRIPTION: "TS Expert is indicating the presence of an optic fiber link with voltage level failure.",
  FIBER_SIGNAL_LOSS_PAGE_DESCRIPTION: "TS Expert is indicating the presence of an optic fiber link with relay failure",

  // ---------------------------- OPTIC FIBER ----------------------------
  OPTIC_FIBER: "Optic Fiber",
  RELAY_STATUS: "Relay status",
  RELAY_SIGNAL: "Relay signal",
  MIN: "Minimum",
  MAX: "Maximum",
  FAULT: "Fault",
  OK: "OK",
  MIN_ANALOG_VALUE: "Minimum analog value",
  MIN_LIMIT_NOT_VALID: "The minimum analog value is not valid",
  STATUS: "Status",
  MAINTENANCE_URGENT: "Urgent Maintenance Value",
  MAINTENANCE_REQUIRED: "Required Maintenance Value",
  DIVERGENCE_MAINTENANCE_VALUE: "The required maintenance value cannot be lower than the urgent maintenance value!",
  INVALID_VALUE: "Invalid Value",
  STR_LIMIT: "Up to",
  CHANNEL_1: "Channel 1",
  CHANNEL_2: "Channel 2",
  CHANNEL_3: "Channel 3",
  CHANNEL_4: "Channel 4",
  CHANNEL_5: "Channel 5",
  ERROR_REASON: "\nReason: ",

  // -----------------------------------------------------------------------------------------------------------------------------------------------
  // -----------------------------------------------------------------------------------------------------------------------------------------------
  // -----------------------------------------------------------------------------------------------------------------------------------------------
  // ------------------------------------------------------ MEIO FÍSICO DP -------------------------------------------------------------------------
  // -----------------------------------------------------------------------------------------------------------------------------------------------
  // -----------------------------------------------------------------------------------------------------------------------------------------------
  // -----------------------------------------------------------------------------------------------------------------------------------------------

  /// ---------------------------- Menu Bar ------------------------- 
  LIVE_LIST_MATRIX: "Matrix",
  OSCILLOSCOPE: "Oscilloscope",
  BAR_GRAPH: "Bar graph",
  INFOS: "Agenda",
  CONFIG: "Settings",

  // ---------------------------- Live List ----------------------------
  GOOD_STRING: "Good",
  ATTENTION_STRING: "Attention",
  BAD_STRING: "Bad",
  NO_SIGNAL_STRING: "No signal",
  UNKNOWN_STRING: "Unknown",

  LIVE_LIST_INPUT_TEXT_PLACEHOLDER_DP: "Filter by address or signal",

  ADDRESSES: "Addresses",
  AMPLITUDE: "Amplitude",
  AMPLITUDE_PRE: "Preamble amplitude",
  MEAN_AMPLITUDE: "Mean amplitude",
  MEAN_AMPLITUDE_N: "Mean\namplitude",
  MIN_AMPLITUDE: "Minimum amplitude",
  MIN_AMPLITUDE_N: "Minimum\namplitude",
  MAX_AMPLITUDE: "Overshoot",
  NOISE: "Noise",
  SIGNAL: "Signal",
  RATIO: "Ratio",
  NETWORK_TAG: "Segment tag",
  IS_IN_SEGMENT: "Belongs to\nsegment?",
  IS_IN_SEGMENT_1: "Belongs to",
  IS_IN_SEGMENT_2: "segment?",
  IS_IN_SEGMENT_DP: "Belongs to segment: ",
  IS_IN_SEGMENT_QUESTION: "Belongs to segment?",
  IS_IN_SEGMENT_LIVE_LIST_POPUP_1: "Indicates whether the device belongs to the same segment as this TS Monitor PROFIBUS PRO.",
  IS_IN_SEGMENT_LIVE_LIST_POPUP_2: "This option must be manually adjusted for each device on the settings screen.",

  MIN_AMPLITUDE_1: "Minimum",
  MIN_AMPLITUDE_2: "amplitude",

  MEAN_AMPLITUDE_1: "Mean",
  MEAN_AMPLITUDE_2: "amplitude",

  RESPONSE_TIME_1: "response",
  RESPONSE_TIME_2: "time",
  CURRENT: "current",
  MINIMUM: "minimum",
  MAXIMUM: "maximum",

  RESPONSE_TIME: "Tresp.\ncurrent",
  MIN_RESPONSE_TIME: "Tresp.\nminimum",
  MAX_RESPONSE_TIME: "Tresp.\nmaximum",

  T_RESP: "Resp. T.",
  RESPONSE_TIME_POPUP: " is the slave device response time. Variations may indicate hardware issues in the devices.",
  MAX_RESPONSE_TIME_POPUP: "Highest response time recorded. Variations may indicate hardware issues in the devices.",
  MIN_RESPONSE_TIME_POPUP: "Lowest response time recorded. Variations may indicate hardware issues in the devices.",

  A: "A",
  B: "B",
  CHANNEL_A_PROBLEM: "This column indicates problems on channel A, green wire, such as:",
  CHANNEL_B_PROBLEM: "This column indicates problems on channel B, red wire, such as:",
  AMPLITUDE_IDLE: "Idle voltage ",

  NETWORK_DATA: "Network data",

  MODAL_TITLE: "Characteristic waveforms",

  TURNED_ON: "On",
  TURNED_OFF: "Off",

  ANALYSIS_ERROR: "An error occurred while changing analysis state",

  ANALYSIS: "Analysis",
  ANALYZER: "TS Scope DP ",

  DETECTED_PROBLEMS: "Detected problems:",
  INIT_PICO_NOT_FOUND: "TS Monitor PROFIBUS PRO not found, please connect it to the computer.",
  INVERTED_AB: "The A and B cables are inverted.",
  MONGO_OFF: "Database error, close the program and open it again. If the error persists, click the button below.",
  PICO_NOT_FOUND: "TS Monitor PROFIBUS PRO is disconnected. After reconnecting it, you must restart the program.",
  MONGO_REPAIR_SUCCESS: "Error repaired successfully! Please close the program and open it again for the changes to take effect.",
  MONGO_REPAIR_ERROR: "Could not solve the problem. Please contact support.",
  INIT_PICO_NOT_FOUND_PLAY: "Error starting TS Monitor PROFIBUS PRO. Please disconnect it from your computer, reconnect it, and restart the program. If the error persists, restart the computer and try again.",

  REPAIR: "Repair",
  LOADING_ANALYZER: "Starting TS Monitor PROFIBUS PRO, please wait.",

  NO_DP_ACTIVE_NETWORK: "TS Monitor PROFIBUS PRO did not find an active network. Make sure it is properly connected to a PROFIBUS DP network and try again.",

  INVALID_SERIAL: "The serial number does not match thisTS Monitor PROFIBUS PRO. Please reinstall the program with a valid serial number.",
  INVERTED_AB_POPUP: "The A and B cables are inverted.\nPlease swap the cables back and press Play again.",

  MONGO_OFF_POPUP: "Error initializing the database, click the button below to repair the problem.",

  MEAN_AMPLITUDE_DESC: "Amplitude value measured between the average of the points at high logic level and the average of the points at low logic level, as illustrated in the figure below.",
  MEAN_AMPLITUDE_DESC_2: "High mean amplitude indicates missing terminators. Low mean amplitude may indicate: resistance in connections; excess terminators; pinched cables; crushed or bent cables, etc.",
  AMPLITUDE_MIN_DESC: "Amplitude value between the lowest point of the waveform at high logic level and the highest point at low logic level, as illustrated in the figure below.",
  AMPLITUDE_MIN_DESC_2: "A large difference between mean amplitude and minimum amplitude indicates: reflection (terminators); long cable; noise; moisture in the bus, etc.",
  OVERSHOOTING_DESC: "Amplitude value between the mean value of the waveform at high logic level and the highest point at high logic level, as illustrated in the figure below.",
  OVERSHOOTING_DESC_2: "Indicates: missing terminators; connections in the middle of the bus; branches, etc.",
  RATIO_DESC_1: "Ratio between the minimum amplitude and mean amplitude values, in order to make signal degradation evident.",
  RATIO_DESC_2: "The closer to 1, the better; and the closer to 0 (zero), the worse the signal quality.",
  RATIO_FOMULA: "Ratio = Min. amp. / Mean amp.",

  IDLE_DESCRIPTION: " Period in which the network is idle, that is, the period between a master request and the slave response, or between packets from the master to itself. The ideal idle voltage is 1V; different values indicate problems on the network.",
  IDLE_DESCRIPTION_2: "If the idle voltage is lower than 0.6 V, the value will be highlighted in orange.",

  MONITOR_IP_NOT_FOUND: "Monitor IP not found",

  CHANNEL_DESCRIPTION_1: "Short circuit",
  CHANNEL_DESCRIPTION_2: "Loose terminal",
  CHANNEL_DESCRIPTION_3: "Broken cable",
  CHANNEL_DESCRIPTION_4: "Or another issue that damages the communication signal.",

  SIGNAL_QUALITY: "Signal quality",
  SIGNAL_QUALITY_DESCRIPTION_1: "In the “Signal” column, the worst-case scenario is always considered for average and minimum amplitude.",

  GOOD: "Good",
  GOOD_DESCRIPTION_1: "• Average amplitude from 4 to 7 V",
  GOOD_DESCRIPTION_2: ". Signal with good amplitude!",

  ATTENTION: "Attention - Preventive action",
  ATTENTION_DESCRIPTION_1: "• Average amplitude from 7 to 8 V",
  ATTENTION_DESCRIPTION_2: ". May indicate missing terminators.",
  ATTENTION_DESCRIPTION_3: "• Average amplitude from 3 to 4 V",
  ATTENTION_DESCRIPTION_4: ". May indicate bus resistance, too many terminators, connection issues, loose terminals, slave issues, etc.",

  BAD: "Bad - Corrective action",

  BAD_DESCRIPTION_1: "• Average amplitude lower than 3 V",
  BAD_DESCRIPTION_2: " or higher than 8 V",
  BAD_DESCRIPTION_3: ", may cause PROFIBUS packet loss.",
  BAD_DESCRIPTION_4: "• Minimum amplitude lower than 3 V",
  BAD_DESCRIPTION_5: " may cause PROFIBUS packet loss.",

  LIGHT_TONES: "Light tones",
  LIGHT_TONES_DESCRIPTION: "• TS Monitor PROFIBUS PRO is not receiving a response from the slave, therefore the software keeps the last captured measurements and uses a light tone to indicate that data is not being updated.",

  // ---------------------------- Oscilloscope ----------------------------
  GRAPH: "Graph",
  A_AND_B: "A and B",
  B_A: "B - A",
  WAVE_FORM: "Waveform",
  AMPLITUDE_A: "Amplitude A",
  AMPLITUDE_B: "Amplitude B",
  ADDRESS_DP: "Address: ",
  WAVE_A: "Signal A",
  WAVE_B: "Signal B",
  WAVE_B_A: "Signal B - A",
  WAVE_PA: "PA Signal",

  NANOSSECOND: "ns",
  MICROSSECOND: " µs",
  MILLISSECOND: " ms",
  SECOND: "s",

  TIME_NS: "Time (ns)",
  TIME_US: "Time (μs)",
  TIME_MS: "Time (ms)",
  TIME_S: "Time (s)",

  AMPLITUDE_PLACEHOLDER: "0.0 V",
  TIME_INTERVAL_PLACEHOLDER: "0.0",
  VOLTAGE: " V",
  VOLTAGE_PEAK_TO_PEAK: " V",
  CURSORS: "Cursors",
  CONTROLS: "Controls ",
  TIME_INTERVAL: " time",
  CONTROLS_POPUP_TEXT: "After pressing PLAY, the waveform is updated approximately every 200 milliseconds.",
  CONTROLS_POPUP_TEXT_2: "To enable the controls, manual view must be selected and a device must be chosen.",

  SIZE: "Size ",
  VISUALIZATION: "Visualization",
  AUTOMATIC: "Automatic",
  MANUAL: "Manual",

  STD_WAVE_FORM: "Standard waveform",
  LONG_CABLE_WAVE_FORM: "Typical long cable waveform",
  EXCESS_TERMINATIOR_WAVE_FORM: "Typical excess terminator waveform",
  NO_SLAVE_WAVE_FORM: "Typical missing slave waveform (disconnected devices)",
  REFLECTION_WAVE_FORM: "Typical waveform with reflection",
  NO_TERMINATOR_WAVE_FORM: "Typical missing terminator waveform",
  FOR_MORE_INFO_DP: "For additional information, consult Toledo & Souza or the PROFIBUS International guidelines. It is worth noting that the events shown may occur together, which changes the illustrated patterns.",
  FEW_TERMINATOR_WAVE_FORM: "Typical waveform with too few terminators",

  WAVE_SIZE_DESC_1: "TS Monitor PROFIBUS PRO already samples the frame in two modes, with only 1 Byte or with 3 Bytes, so here we can view a greater zoom with 1 Byte or a smaller zoom with 3 Bytes.",
  WAVE_SIZE_DESC_2: "There is one exception: the “E5” frame – short acknowledgement – always has only 1 Byte.",
  WAVE_SIZE_DESC_3: "Below is an example in a frame with more than 1 and 3 Bytes.",

  TS_SCOPE_NOT_FINDING_ANSWER: "TS Monitor PROFIBUS PRO is not finding the slave response, therefore the data is outdated. The waveform below is the last one captured by the system.",

  TIME_DP: "Time: ",
  PS_1: "PS 1:",
  PS_2: "PS 2:",
  PS_3: "PS 3:",

  // ---------------------------- Bar Graph ----------------------------
  ORDER_BY: "Sort by",
  AMPLITUDE_ASC: "Ascending amplitude",
  AMPLITUDE_DESC: "Descending amplitude",
  ADDRESS_ASC: "Ascending address",
  VOLTAGE_V: "Voltage (V)",
  VOLTAGE_V_PEAK_TO_PEAK: "Voltage (V)",
  VOLTAGE_MV: "Voltage (mV)",
  VOLTAGE_MV_PEAK_TO_PEAK: "Voltage (mV)",
  ORDER: "Ordering",
  REFRESH_DATA: "Refresh data",
  LOADING: "Loading",

  // ---------------------------- Log ----------------------------
  INSERT_VALID_TYPE: "Please enter a valid event type.",
  LOG_INPUT_TEXT_PLACEHOLDER_DP: "Filter by event type",
  TYPE: "Type",

  TERMINATION_OFF_LOG_DESCRIPTION: "TS Expert detected a possible missing terminator on the network.",
  NO_TERMINATION_LOG_DESCRIPTION: "TS Expert detected a possible absence of a terminator in the segment to which it is connected.",
  NO_POWER_SUPPLY_LOG_DESCRIPTION: "TS Expert detected a possible lack of power supply to the terminator.",
  HIGH_RESISTANCE_LOG_DESCRIPTION: "TS Expert detected a possible excess of terminators or high resistance on the PROFIBUS bus.",
  A_NOT_OK_LOG_DESCRIPTION: "TS Expert detected a possible short circuit between conductor A and the shield mesh, or the grounded mass of a panel or slave.",
  B_NOT_OK_LOG_DESCRIPTION: "TS Expert detected a possible short circuit between conductor B and the shield mesh, or the grounded mass of a panel or slave.",
  LONG_CABLE_LOG_DESCRIPTION: "TS Expert detected a possible bus condition with a length greater than allowed.",
  NOISE_LOG_DESCRIPTION: "TS Expert detected a possible noise condition on the PROFIBUS network.",
  REFLECTION_LOG_DESCRIPTION: "TS Expert detected the presence of reflection in the waveform.",
  DEFORMED_WAVE_LOG_DESCRIPTION: "TS Expert detected the presence of an out-of-standard signal.",
  DUPLICATE_LOG_DESCRIPTION: "TS Expert detected a possible presence of two slaves with the same address on the network.",
  EVENT_CHECKED_SUCCESS: "The event was checked successfully.",
  OPTIC_FIBER_EVENT_CHECKED_SUCCESS: "The event was cleared successfully.",

  // ---------------------------- Report ----------------------------
  REPORT_EXPORT_NAME_DP: "TS Monitor PROFIBUS PRO Report - DP Physical Layer",
  HEADER_TEXT_DP: "Data report - TS Monitor PROFIBUS PRO - DP Physical Layer",

  ANALYZER_VERSION_STRING: "- Monitor version:",
  ANALYZER_VERSION: "4.0.0",

  PROTOCOL: "- Protocol:",
  PROTOCOL_TYPE: "PROFIBUS DP",

  ANALYSIS_INIT: "- Monitoring start:",
  REPORT_GENERATION: "- Report generation:",
  ANALYSIS_DURATION: "- Monitoring duration until report generation: ",

  REPORT_TYPE: "Report Type",

  CONFORM: "Compliant",
  CONFORM_W_RESTRICTION: "Compliant with restrictions",
  NON_CONFORM: "Non-compliant",

  A_LIVE_LIST_PAGE_TITLE: "1. - Live List",
  A_OSCILLOSCOPE_PAGE_TITLE: "2. - Oscilloscope",
  A_BAR_GRAPH_PAGE_TITLE: "3. - Bar graph",
  A_LOG_PAGE_TITLE: "4. - Event log",

  B_LIVE_LIST_PAGE_TITLE: "2.1. - Live List",
  B_OSCILLOSCOPE_PAGE_TITLE: "2.2. - Oscilloscope",
  B_BAR_GRAPH_PAGE_TITLE: "2.3. - Bar graph",
  B_LOG_PAGE_TITLE: "2.4. - Event log",

  ANALYSIS_INFO: "Monitoring information",
  GENERATED_BY: "- Generated by TS Monitor PROFIBUS PRO",
  HARDWARE_VERSION: "- Hardware version:",
  SOFTWARE_VERSION: "- Software version:",
  DATE_TIME: "- Date and time:",
  BAUD_RATE: "- Baud rate:",
  CYCLE_TIME: "- Cycle time:",
  NUM_MASTERS: "- Masters:",
  NUM_SLAVES: "- Slaves:",
  AMPLITUDE_IDLE_1: "- Idle voltage:",
  SEGMENT_TAG: "- Segment tag: ",

  LIVE_LIST_DOTS_DP: "........................................................................................................................................",
  BAR_DOTS_DP: "......................................................................................................................................",
  OSC_DOTS_DP: "................................................................................................................................",
  LOG_DOTS_DP: "................................................................................................................................................",
  DISCLAIMER_DOTS_DP: "...........................................................................................................................",

  SELECT_REPORT_TYPE: "Please select a report type",

  MASTER_DP: "Master: ",
  SLAVE_DP: "Slave: ",
  SIGNAL_DP: "Signal: ",
  AMPLITUDE_DP: "Amplitude: ",
  AMPLITUDE_PRE_DP: "Preamble amplitude: ",
  AMPLITUDE_MIN_DP: "Minimum amplitude: ",
  OVERSHOOTING_DP: "Overshoot: ",
  AMPLITUDE_MAX_DP: "Maximum amplitude: ",

  GENERAL_INFORMATION: "General information",

  CAPTURE_TIME: "Capture time",

  PROJECT_NAME_LABEL: "Project name",
  NETWORK_LABEL: "Network name",
  LOCATION_LABEL: "Location",
  COMPANY_NAME_LABEL: "Company name",
  ACCOUNTABLE_NAME_LABEL: "Responsible person's name",
  CITY_LABEL: "City",
  TEL_LABEL: "Telephone",
  CLIENT_LOGO_LABEL: "Client logo",
  EMAIL_LABEL: "E-mail",
  EXECUTING_COMPANY_LOGO_LABEL: "Executing company logo",
  FINISHING: "Finishing...",
  SAVE_REPORT: "Save report",
  SLAVE_NOT_FOUND_SHOWING_LAST_WAVEFORM: "Slave not found on the network, showing last captured waveform.",
  REPORT_MN_PB_PRO_FULL: "Report - TS Monitor PROFIBUS PRO - Full",
  REPORT_MN_PB_PRO_PROTOCOL: "Report - TS Monitor PROFIBUS PRO - Protocol",
  REPORT_MN_PB_PRO_PHYS_MEDIUM: "Report - TS Monitor PROFIBUS PRO - Physical Medium DP",
  MASTER: "Master ",

  // ---------------------------- Configuration page related ----------------------------
  LOGIN: "LOGIN",
  ENTER: "Enter",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LOG_DESCRIPTION: "TS Expert detected a possible voltage level failure (Action Required).",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LOG_DESCRIPTION: "TS Expert detected a possible voltage level failure (Urgent Action).",
  FIBER_SIGNAL_LOSS_LOG_DESCRIPTION: "TS Expert detected a possible relay failure.",

  LOGOUT: "Logout",
  MASK: "Mask",
  TAGS: "Tags",
  INTERFACE_CONFIG: "Interface settings",
  ARE_YOU_SURE_ALTER_CONFIG: "Are you sure you want to change the Ethernet settings of TS Monitor PROFIBUS PRO?",

  GPG_FILE_EXTENSION: ".gpg",
  SEND_FILE_SUCCESS: "The file was sent successfully.",
  SEND_FILE_SUCCESS_WARNING: "Do not forget to check whether your computer's network card is on the same subnet as IP: ",
  SEND_CONFIG_SUCCESS: "The settings were sent successfully.",
  START_MESSAGE_SUCCESS: "The monitor will start in 15 seconds.",
  START_MESSAGE_FAILURE: "An error occurred while starting the monitor.",
  STOP_MESSAGE_SUCCESS: "The monitor will stop in 15 seconds.",
  STOP_MESSAGE_FAILURE: "An error occurred while stopping the monitor.",
  RESET_TRAFFIC_SUCCESS: "The values will be reset on the next scan.",
  RESET_TRAFFIC_FAILURE: "An error occurred while resetting the error increments.",
  RESET_DEVICES_SUCCESS: "Device data was cleared successfully.",
  RESET_DEVICES_FAILURE: "An error occurred while clearing device data.",
  RESET_RETRIES_SUCCESS: "Retries were cleared successfully.",
  RESET_RETRIES_FAILURE: "An error occurred while clearing the retries.",

  TAG_TOO_LONG: "\n- The tag length cannot exceed 30 characters",

  SYSTEM: "System",
  RESTART: "Restart",

  SCOPE_DP_IP_WAS_CHANGED_SUCCESSFULLY: "• The TS Monitor PROFIBUS PRO IP was changed successfully.",
  NOTE_WAS_CHANGED_SUCCESSFULLY: "• The note was changed successfully.",

  NOTE: "Note",
  MONITOR_IP: "Monitor IP",

  IN_SEGMENT_DEVICES: "Segment devices",
  UPDATING_DATA: "Updating information, please wait",
  IN_SEGMENT_FORM_INPUT_PLACEHOLDER: "Filter devices by address",

  IS_IN_SEGMENT_POPUP_DESCRIPTION_1: "List of devices belonging to the same segment as TS Monitor PROFIBUS PRO.",
  IS_IN_SEGMENT_POPUP_DESCRIPTION_2: "If the device is unchecked in this list, it means it does not belong to the same segment as TS Monitor PROFIBUS PRO.",
  IS_IN_SEGMENT_POPUP_DESCRIPTION_3: "If it does not belong to the same segment, the waveform seen on the oscilloscope may not correspond to the actual waveform of the device.",

  CONFIRM_ALTER_SEGMENT_DEVICES: "Are you sure you want to apply the changes to the list of devices belonging to the segment?",

  ALTER_IS_IN_SEGMENT_LIST_FAILURE: "An error occurred while changing the segment device list.",
  ALTER_IS_IN_SEGMENT_LIST_SUCCESS: "The segment device list was changed successfully!",

  TS_EXPERT_CONFIG_POPUP: "Allows enabling/disabling the non-conformities to be reported by the tool.",

  NTP_INFO_TURNED_ON_SUCCESS: "The NTP server was turned on successfully.",
  TURN_ON_DATE: "\nThe server time was updated to: ",

  MONITOR_WILL_BE_RESTARTED: "\nTS Monitor PROFIBUS PRO will be restarted now,",

  NTP_INFO_TURNED_OFF_SUCCESS: "The NTP server was turned off successfully.",
  TURN_OFF_DATE: "\nShutdown time: ",

  TAG_CONFIG_DP: "Segment tag",

  INVALID_MONITOR_IP: "The entered monitor IP is invalid.",
  MONITOR_IP_WAS_CHANGED_SUCCESSFULLY: "The monitor IP was changed successfully.",
  MONITOR_IP_CHANGE_FAILURE: "An error occurred while changing the monitor IP.",

  INVALID_HOSTNAME: "The hostname must not be blank, contain spaces, or special characters.",

  CHANGE_IDLE_SIZE: "Change idle size",
  CHANGE_IDLE_SIZE_QUESTION_1: "Changing the idle size will restart the internal procedures of TS Monitor PROFIBUS PRO. This procedure may take up to 3 minutes.",
  CHANGE_IDLE_SIZE_QUESTION_2: "After clicking yes, wait on the screen until completion. Are you sure you want to proceed?",

  CHANGE_PACKET_SIZE: "Change packet size",
  CHANGE_PACKET_SIZE_QUESTION_1: "Changing the packet size will restart the internal procedures of TS Monitor PROFIBUS PRO. This procedure may take up to 3 minutes.",
  CHANGE_PACKET_SIZE_QUESTION_2: "After clicking yes, wait on the screen until completion. Are you sure you want to proceed?",

  // ---------------------------- TS EXPERT CONFIG ---------------------------- 
  TERMINATION_OFF_LIST_HEADER: "Terminator in OFF position",
  TERMINATION_OFF_LIST_CONTENT: "When this option is enabled, TS Expert will indicate a possible missing terminator on the network.",

  NO_TERMINATION_LIST_HEADER: "Segment without termination",
  NO_TERMINATION_LIST_CONTENT: "When this option is enabled, TS Expert will indicate a possible absence of a terminator in the segment to which it is connected.",

  NO_POWER_SUPPLY_LIST_HEADER: "Terminator without power supply",
  NO_POWER_SUPPLY_LIST_CONTENT: "When this option is enabled, TS Expert will indicate a possible lack of power supply to the terminator.",

  HIGH_RESISTANCE_LIST_HEADER: "Attenuated signal",
  HIGH_RESISTANCE_LIST_CONTENT: "When this option is enabled, TS Expert will indicate a possible excess of terminators or high resistance on the PROFIBUS bus.",

  A_NOT_OK_LIST_HEADER: "Short between conductor A and shield",
  A_NOT_OK_LIST_CONTENT: "When this option is enabled, TS Expert will indicate a possible short circuit between conductor A and the shield mesh or the grounded mass of a panel or slave.",

  B_NOT_OK_LIST_HEADER: "Short between conductor B and shield",
  B_NOT_OK_LIST_CONTENT: "When this option is enabled, TS Expert will indicate a possible short circuit between conductor B and the shield mesh or the grounded mass of a panel or slave.",

  LONG_CABLE_LIST_HEADER: "Long cable",
  LONG_CABLE_LIST_CONTENT: "When this option is enabled, TS Expert will indicate a possible bus condition with length greater than allowed.",

  NOISE_LIST_HEADER: "Noise or low insulation (ground leakage)",
  NOISE_LIST_CONTENT: "When this option is enabled, TS Expert will indicate a possible noise condition on the PROFIBUS network.",

  REFLECTION_LIST_HEADER: "Reflection in the waveform",
  REFLECTION_LIST_CONTENT: "When this option is enabled, TS Expert will indicate the presence of reflection in the waveform.",

  DEFORMED_WAVE_LIST_HEADER: "Deformed signal",
  DEFORMED_WAVE_LIST_CONTENT: "When this option is enabled, TS Expert will indicate the presence of an out-of-standard signal.",

  DUPLICATE_ADDRESS_LIST_HEADER: "Duplicate address",
  DUPLICATE_ADDRESS_LIST_CONTENT: "When this option is enabled, TS Expert will indicate a possible presence of two slaves with the same address on the network.",

  // ---------------------------- TS EXPERT ----------------------------

  QUANTITY_DP: "Quantity: ",
  INCREMENTS: "Increments",

  PORT_IS_STILL_INACTIVE: "The port is still inactive",
  MARK_PROBLEM_AS_SOLVED: "Are you sure you want to mark the event as checked?",

  ALL_EVENTS_CHECKED: "All events have been successfully checked.",

  DEVICES: "Devices",

  // ---------------------------- TERMINADOR OFF ----------------------------
  TERMINATION_OFF_SUGGESTION_1: "When the terminator is in the OFF position, the following is suggested:",
  TERMINATION_OFF_SUGGESTION_2: "Check visually:",
  TERMINATION_OFF_SUGGESTION_3: "Whether the terminators at both ends of the segment are in the \"on\" position;",
  TERMINATION_OFF_SUGGESTION_4: "If PROFIBUS connectors are not used, verify whether there is an active terminator at both ends;",
  TERMINATION_OFF_SUGGESTION_5: "If there is no terminator at one end, installation is required.",
  TERMINATION_OFF_SUGGESTION_6: "It is recommended to wait for a shutdown or schedule with production before switching on the turned-off terminator or installing an active terminator, since this change may bring the network down.",

  // ---------------------------- SEM TERMINADOR ----------------------------
  NO_TERMINATION_SUGGESTION_1: "When the segment has no termination, the following is suggested:",
  NO_TERMINATION_SUGGESTION_2: "Check visually whether:",

  NO_TERMINATION_SUGGESTION_3: "Whether the terminators at both ends of the segment are in the \"on\" position;",
  NO_TERMINATION_SUGGESTION_4: "If PROFIBUS connectors are not used, verify whether there is an active terminator at both ends;",
  NO_TERMINATION_SUGGESTION_5: "If there is no terminator at one end, installation is required.",

  NO_TERMINATION_SUGGESTION_6: "It is recommended to wait for a shutdown or schedule with production before switching on the turned-off terminator or installing an active terminator, since this change may bring the network down.",

  // ---------------------------- NO POWER SUPPLY ----------------------------
  NO_POWER_SUPPLY_SUGGESTION_1: "When the terminator has no power supply, the following is suggested:",
  NO_POWER_SUPPLY_SUGGESTION_2: "Check the power supply of active terminators (when the device is installed) and the power supply for terminators in the slave or master at the DB9 connector pins, as follows:",
  NO_POWER_SUPPLY_SUGGESTION_3: "In the case of an active terminator, simply power it; but in the case of a DB9 connector, it is necessary to check whether the problem is in the connector or in the power coming from the slave or master.",
  NO_POWER_SUPPLY_SUGGESTION_4: "It is recommended to perform these procedures with production stopped, since this change may bring the network down.",

  // ---------------------------- HIGH RESISTANCE ----------------------------
  HIGH_RESISTANCE_SUGGESTION_1: "When the signal is attenuated, the following is suggested:",
  HIGH_RESISTANCE_SUGGESTION_2: "Check:",

  HIGH_RESISTANCE_SUGGESTION_3: "Whether any device in the segment has an internal terminator switched on;",
  HIGH_RESISTANCE_SUGGESTION_4: "If no device has an internal terminator switched on, check the slave electronics by isolating them individually from the bus;",
  HIGH_RESISTANCE_SUGGESTION_5: "Check for loose terminals in terminal block connections or terminal block connectors;",
  HIGH_RESISTANCE_SUGGESTION_6: "Check for poor contact in “vampire” type connectors;",
  HIGH_RESISTANCE_SUGGESTION_7: "Check whether there are crushed cables, which would increase cable resistance.",

  HIGH_RESISTANCE_SUGGESTION_8: "This check can be performed while the network is operating, but for any intervention it is recommended to wait for a shutdown, since these changes may bring the network down.",

  // ---------------------------- A NOT OK ----------------------------
  A_NOT_OK_SUGGESTION_1: "When there is a short between conductor A and the shield, the following is suggested:",
  A_NOT_OK_SUGGESTION_2: "Perform a visual inspection:",
  A_NOT_OK_SUGGESTION_3: "Inside the connectors, checking whether there is a short between conductor A and the shield;",
  A_NOT_OK_SUGGESTION_4: "Throughout the segment, checking whether there is any section of damaged cable pinched in a cable tray, cut at a conduit outlet, or crushed by an MCC drawer, etc.",

  // ---------------------------- B NOT OK ----------------------------
  B_NOT_OK_SUGGESTION_1: "When there is a short between conductor B and the shield, the following is suggested:",
  B_NOT_OK_SUGGESTION_2: "Perform a visual inspection:",
  B_NOT_OK_SUGGESTION_3: "Inside the connectors, checking whether there is a short between conductor B and the shield;",
  B_NOT_OK_SUGGESTION_4: "Throughout the segment, checking whether there is any section of damaged cable pinched in a cable tray, cut at a conduit outlet, or crushed by an MCC drawer, etc.",

  // ---------------------------- LONG CABLE ----------------------------
  LONG_CABLE_SUGGESTION_1: "When the cable is too long, the following is suggested:",
  LONG_CABLE_SUGGESTION_2: "Perform a visual inspection of the segment and check whether the bus is too long for the baud rate (communication rate), according to the table below.",
  LONG_CABLE_SUGGESTION_3: "If the segment is longer than allowed, it is suggested to insert a repeater or fiber optic link, dividing the segment.",

  BAUD_RATE_: "Baud rate",
  LENGTH: "Length",
  NINE_SIX_KBITS: "9.6 kbit/s",
  NINETEEN_KBITS: "19.2 kbit/s",
  FORTY_FIVE_KBITS: "45.45 kbit/s",
  NINETY_THREE_KBITS: "93.75 kbit/s",
  HUN_EIGHTY_SEVEN_KBITS: "187.5 kbit/s",
  FIVE_HUNDRED_KBITS: "500.0 kbit/s",
  ONE_FIVE_KBITS: "1.5 Mbit/s",
  THREE_MBPS: "3.0 Mbit/s",
  SIX_MBPS: "6.0 Mbit/s",
  TWELVE_MBPS: "12.0 Mbit/s",

  // ---------------------------- NOISE ----------------------------
  NOISE_SUGGESTION_1: "When there is noise or low insulation (ground leakage), the following is suggested:",
  NOISE_SUGGESTION_2: "3 tips tend to help solve this problem:",
  NOISE_SUGGESTION_3: "To attenuate the noise, it is necessary to verify whether all slaves on the network are properly grounded;",
  NOISE_SUGGESTION_4: "Current measured on the shield with the shield grounded at both ends:",
  NOISE_SUGGESTION_5: "Check the insulation of the slave interfaces; a simple way is to disconnect the slaves from the segment one by one and verify in TS Monitor PROFIBUS PRO whether the problem persists, that is, whether the signals in the Live List stabilize at GOOD).",
  NOISE_SUGGESTION_6: "If the problem persists after these tips, we recommend seeking a PROFIBUS network specialist.",

  NOISE_SUGGESTION_TABLE_HEADER_1: "Current",
  NOISE_SUGGESTION_TABLE_HEADER_2: "Action",

  NOISE_SUGGESTION_TABLE_11: "5 mA",
  NOISE_SUGGESTION_TABLE_12: "Very good value, especially recommended for plants.",
  NOISE_SUGGESTION_TABLE_21: "30 mA",
  NOISE_SUGGESTION_TABLE_22: "No action is required outside hazardous areas.",
  NOISE_SUGGESTION_TABLE_31: "30 mA to 100 mA",
  NOISE_SUGGESTION_TABLE_321: "Investigate the cause and reduce the value below ",
  NOISE_SUGGESTION_TABLE_322: "30 mA",
  NOISE_SUGGESTION_TABLE_323: ", if possible.",
  NOISE_SUGGESTION_TABLE_41: "100 mA",
  NOISE_SUGGESTION_TABLE_42: "Eliminate the source of interference, improve/interconnect the equipotential bonding network, reduce stray currents and, if necessary, increase the distance between power lines and bus lines.",
  NECESSARY_ACTION: "Required action: ",

  // ---------------------------- REFLECTION ----------------------------
  REFLECTION_SUGGESTION_1: "When there is reflection in the waveform, the following is suggested:",
  REFLECTION_SUGGESTION_2: "This event is almost always associated with missing termination on the network; therefore, the following should be visually checked:",

  REFLECTION_SUGGESTION_3: "Whether the terminators at both ends of the segment are in the “on” position;",
  REFLECTION_SUGGESTION_4: "If PROFIBUS connectors are not used, verify whether there is an active terminator at both ends;",
  REFLECTION_SUGGESTION_5: "If there is no terminator at one end, installation is required.",

  REFLECTION_SUGGESTION_6: "However, reflection may also result from a cable splice, use of inadequate terminals, crushed cables, change of cable type, use of splices with M12, or any other change in the communication physical layer.",
  REFLECTION_SUGGESTION_7: "In these cases, a detailed visual inspection of the indicated network segment is required.",

  // ---------------------------- DEFORMED WAVE ----------------------------
  DEFORMED_WAVE_SUGGESTION_1: "When a deformed signal is detected, the following is suggested:",
  DEFORMED_WAVE_SUGGESTION_2: "Check the bus for:",
  DEFORMED_WAVE_SUGGESTION_3: "Slave with duplicate address;",
  DEFORMED_WAVE_SUGGESTION_4: "Bent cables;",
  DEFORMED_WAVE_SUGGESTION_5: "Loose terminals;",
  DEFORMED_WAVE_SUGGESTION_6: "Poorly assembled connectors;",
  DEFORMED_WAVE_SUGGESTION_7: "Crushed cables;",
  DEFORMED_WAVE_SUGGESTION_8: "Cut or damaged cables;",
  DEFORMED_WAVE_SUGGESTION_9: "Incorrect power supply to active terminators.",

  // ---------------------------- DUPLICATE ADDRESS ----------------------------
  DUPLICATE_IP_SUGGESTION_1: "When an address is duplicated, the following is suggested:",
  DUPLICATE_IP_SUGGESTION_2: "Perform a visual inspection of the network and verify whether there are two or more slaves with the same address. If so, determine which slave is correct and assign the other one to a free node.",

  // ---------------------------- EXPERT REPORT ----------------------------
  SAVE_ACTIONS_LIST: "Save actions list",
  ACTIONS_LIST_FILENAME_PART: "Actions List - TS Monitor PROFIBUS PRO",

  TERMINATION_OFF_PAGE_TITLE: ". - Terminator in OFF position",
  NO_TERMINATION_PAGE_TITLE: ". - Segment without termination",
  NO_POWER_SUPPLY_TERMINATION_PAGE_TITLE: ". - Terminator without power supply",
  HIGH_RESISTANCE_PAGE_TITLE: ". - Attenuated signal",
  A_NOT_OK_PAGE_TITLE: ". - Short between conductor A and shield",
  B_NOT_OK_PAGE_TITLE: ". - Short between conductor B and shield",
  LONG_CABLE_PAGE_TITLE: ". - Long cable",
  NOISE_PAGE_TITLE: ". - Noise or low insulation (ground leakage)",
  REFLECTION_PAGE_TITLE: ". - Reflection in the waveform",
  DEFORMED_WAVE_PAGE_TITLE: ". - Deformed signal",
  DUPLICATE_PAGE_TITLE: ". - Duplicate address",

  TERMINATION_OFF_DOTS: ".........................................................................................................",
  NO_TERMINATION_DOTS: "........................................................................................................",
  NO_POWER_SUPPLY_DOTS: "..............................................................................................",
  HIGH_RESISTANCE_DOTS: ".......................................................................................................................",
  A_NOT_OK_DOTS: ".....................................................................................",
  B_NOT_OK_DOTS: ".....................................................................................",
  LONG_CABLE_DOTS: "...................................................................................................................................",
  NOISE_DOTS: ".................................................................................",
  REFLECTION_DOTS: "........................................................................................................",
  DEFORMED_WAVE_DOTS: ".......................................................................................................................",
  DEFORMED_WAVE_DOTS_2: ".........................................................................................................................",

  DUPLICATE_ADDRESS_DOTS: "..................................................................................................................",
  DUPLICATE_ADDRESS_DOTS_2: "....................................................................................................................",

  SUGGESTION: "Suggestion",
  EVIDENCE: "Evidence",
  EVIDENCE_DESCRIPTION: "Evidence capture of the non-conformity reported by TS Expert:",

  TERMINATION_OFF_PAGE_DESCRIPTION: "TS Expert is indicating a possible missing terminator on the network.",
  NO_TERMINATION_PAGE_DESCRIPTION: "TS Expert is indicating a possible absence of a terminator in the segment to which it is connected.",
  NO_POWER_SUPPLY_PAGE_DESCRIPTION: "TS Expert is indicating a possible lack of power supply to the terminator.",
  HIGH_RESISTANCE_PAGE_DESCRIPTION: "TS Expert is indicating a possible excess of terminators or high resistance on the PROFIBUS bus.",
  A_NOT_OK_PAGE_DESCRIPTION: "TS Expert is indicating a possible short circuit between conductor A and the shield mesh or the grounded mass of a panel or slave.",
  B_NOT_OK_PAGE_DESCRIPTION: "TS Expert is indicating a possible short circuit between conductor B and the shield mesh or the grounded mass of a panel or slave.",
  LONG_CABLE_PAGE_DESCRIPTION: "TS Expert is indicating a possible bus condition with a length greater than allowed.",
  NOISE_PAGE_DESCRIPTION: "TS Expert is indicating a possible noise condition on the PROFIBUS network.",
  REFLECTION_PAGE_DESCRIPTION: "TS Expert is indicating the presence of reflection in the waveform.",
  DEFORMED_WAVE_PAGE_DESCRIPTION: "TS Expert is indicating the presence of an out-of-standard signal",
  DUPLICATE_PAGE_DESCRIPTION: "TS Expert is indicating the possible presence of a duplicate address.",

  TERMINATION_OFF_INITIAL_ERROR_MSG: "It was not possible to check the events of the following devices, as a terminator in the OFF position is still being detected:\n",
  NO_POWER_SUPPLY_INITIAL_ERROR_MSG: "It was not possible to check the events of the following devices, as a terminator without power supply is still being detected:\n",
  HIGH_RESISTANCE_INITIAL_ERROR_MSG: "It was not possible to check the events of the following devices, as an attenuated signal is still being detected:\n",
  A_NOT_OK_INITIAL_ERROR_MSG: "It was not possible to check the events of the following devices, as a short circuit between conductor A and the shield is still being detected:\n",
  B_NOT_OK_INITIAL_ERROR_MSG: "It was not possible to check the events of the following devices, as a short circuit between conductor B and the shield is still being detected:\n",
  LONG_CABLE_INITIAL_ERROR_MSG: "It was not possible to check the events of the following devices, as a long cable is still being detected:\n",
  NOISE_INITIAL_ERROR_MSG: "It was not possible to check the events of the following devices, as noise or low insulation is still being detected:\n",
  REFLECTION_INITIAL_ERROR_MSG: "It was not possible to check the events of the following devices, as waveform reflection is still being detected:\n",

  S_TERMINATION_OFF_INITIAL_ERROR_MSG: "It was not possible to check the device event, as a terminator in the OFF position is still being detected\n",
  S_NO_POWER_SUPPLY_INITIAL_ERROR_MSG: "It was not possible to check the device event, as the terminator is still being detected without power supply\n",
  S_HIGH_RESISTANCE_INITIAL_ERROR_MSG: "It was not possible to check the device event, as it is still being detected that there are 2 terminators, or that the bus resistance is high\n",
  S_A_NOT_OK_INITIAL_ERROR_MSG: "It was not possible to check the device event, as a possible short circuit between conductor A and the shield or grounded panel/slave is still being detected\n",
  S_B_NOT_OK_INITIAL_ERROR_MSG: "It was not possible to check the device event, as a possible short circuit between conductor B and the shield or grounded panel/slave is still being detected\n",
  S_LONG_CABLE_INITIAL_ERROR_MSG: "It was not possible to check the device event, as a possible bus condition with excessive cable length is still being detected\n",
  S_NOISE_INITIAL_ERROR_MSG: "It was not possible to check the device event, as a possible noise condition in the PROFIBUS network is still being detected\n",
  S_REFLECTION_INITIAL_ERROR_MSG: "It was not possible to check the device event, as waveform reflection is still being detected\n",

  // ---------------------------- Temperature Alert ----------------------------
  IDLE_SIZE: "Idle size",
  PACKET_SIZE: "Packet size",

  SMALL: "Small",
  MEDIUM: "Medium",
  BIG: "Large",

  IDLE_SIZE_QUESTION_ICON_INFO: "Idle size refers to the number of points considered at the beginning of the device response waveform. It is possible to configure three different sizes:",
  IDLE_SIZE_QUESTION_ICON_INFO_1: "Standard idle size (varies according to baud rate);",
  IDLE_SIZE_QUESTION_ICON_INFO_2: "Increases the size by 1 bit time;",
  IDLE_SIZE_QUESTION_ICON_INFO_3: "Increases the size by 2 bit times.",

  PACKET_SIZE_QUESTION_ICON_INFO: "Packet size is the total number of points captured by TS Monitor PROFIBUS PRO in a single data packet. It is possible to configure three different sizes:",
  PACKET_SIZE_QUESTION_ICON_INFO_1: "Standard packet size (varies according to baud rate);",
  PACKET_SIZE_QUESTION_ICON_INFO_2: "Increases packet size by 100 points;",
  PACKET_SIZE_QUESTION_ICON_INFO_3: "Increases packet size by 200 points.",

  IDLE_SIZE_WAITING: "Performing procedures to change idle size. Please remain on this screen until they are completed.",
  IDLE_SIZE_WAS_CHANGED_SUCCESSFULLY: "Idle size was changed successfully",
  IDLE_SIZE_CHANGE_FAILURE: "An error occurred while changing idle size.",

  PACKET_SIZE_WAITING: "Performing procedures to change packet size. Please remain on this screen until they are completed.",
  PACKET_SIZE_WAS_CHANGED_SUCCESSFULLY: "Packet size was changed successfully",
  PACKET_SIZE_CHANGE_FAILURE: "An error occurred while changing packet size.",

  REASON_DP: "Reason: ",

  // ---------------------------- Segment Devices ----------------------------
  CHECK_MASTER: "Check master",
  START_SEARCH_ERROR_MESSAGE: "An error occurred while starting the device search. Please try again.",
  SEARCH_FINISH_SUCCESS: "Device search completed successfully!",
  GET_DEVICES_LIST_ERROR: "An error occurred while loading the device list.",

  IN_SEGMENT: "Currently in segment",
  POSSIBLY_IN_SEGMENT: "Identified as belonging",
  POSSIBLY_OUT_OF_SEGMENT: "This device may belong to another segment",

  SEND_SEGMENT_DEVICES_INFO_SUCCESS: "Information about the segment devices was sent successfully!",
  SEND_SEGMENT_DEVICES_INFO_ERROR: "An error occurred while sending the information about the segment devices.",

  SEARCH: "Search",
  SEARCH_POPUP_1: "To use the DP Physical Layer section for the first time, it is recommended to select which devices belong to the segment.",
  SEARCH_POPUP_2: "Press the button below to run a search and find all reachable devices on the network.",
  SEARCH_POPUP_3_1: "After the search, the found devices will be added to the list of ",
  SEARCH_POPUP_3_2: "available devices",
  SEARCH_POPUP_3_3: " on the side. Available devices ",
  SEARCH_POPUP_3_4: "are all devices found, whether they belong to the current network segment or not.",
  SEARCH_POPUP_4_1: "The other list, of ",
  SEARCH_POPUP_4_2: "selected devices",
  SEARCH_POPUP_4_3: ", is the list that ",
  SEARCH_POPUP_4_4: "contains the devices selected by the user that they are sure belong to the current network segment.",
  SEARCH_POPUP_4_5: " Initially, this list will be empty.",
  SEARCH_POPUP_5: "Once the search is done, the user must select which of these devices actually belong to the network segment, moving them from the available devices list to the selected devices list.",
  SEARCH_POPUP_6_1: "NOTE: ",
  SEARCH_POPUP_6_2: "Network masters are always monitored by TS Monitor PROFIBUS PRO, so they do not appear on this page.",

  SAVE_POPUP_1_1: "By clicking the button below, the devices in the ",
  SAVE_POPUP_1_2: "Selected devices",
  SAVE_POPUP_1_3: " list will be saved.",
  SAVE_POPUP_2_1: "By performing this procedure, only the devices in the ",
  SAVE_POPUP_2_2: "Selected devices",
  SAVE_POPUP_2_3: " list will be monitored by DP Physical Layer, and ",
  SAVE_POPUP_2_4: "only they will be shown on the DP Physical Layer screens, such as: Live List, Matrix, Oscilloscope, etc.",

  EXPLANATION: "Explanation",

  SAVE_POPUP_3: "This feature is important to identify the slaves belonging to the PROFIBUS network segment, which reduces response time since the system will be checking the relevant slaves.",
  SAVE_POPUP_4: "It is also very useful so that those with less knowledge of the network do not look for the problem in the wrong segment.",

  AVAILABLE_DEVICES: "Available devices",
  AVAILABLE_DEVICES_POPUP_1_1: "This list contains all devices ",
  AVAILABLE_DEVICES_POPUP_1_2: "found on the network.",
  AVAILABLE_DEVICES_POPUP_2: "TS Monitor PROFIBUS PRO suggests the devices it believes belong to the current network segment, indicating them as: ",
  AVAILABLE_DEVICES_POPUP_2_1: " Identified as belonging.",

  AVAILABLE_DEVICES_POPUP_3_1: "Clicking the button ",
  AVAILABLE_DEVICES_POPUP_3_2: " moves a device from the ",
  AVAILABLE_DEVICES_POPUP_3_3: "available devices",
  AVAILABLE_DEVICES_POPUP_3_4: " list to the ",
  AVAILABLE_DEVICES_POPUP_3_5: "selected devices",
  AVAILABLE_DEVICES_POPUP_3_6: " list, indicating that it belongs to the current network segment. After moving the devices, it is necessary to click the ",
  AVAILABLE_DEVICES_POPUP_3_7: "Save",
  AVAILABLE_DEVICES_POPUP_3_8: " button to record these changes.",

  AVAILABLE_DEVICES_POPUP_4_1: "NOTE: ",
  AVAILABLE_DEVICES_POPUP_4_2: "It is up to the user to make the final decision and determine which devices really belong to the segment.",

  LOADING_DEVICES: "Loading devices",

  MOVE_ALL: "Move all",

  SELECTED_DEVICES: "Selected devices",

  SELECTED_DEVICES_POPUP_1_1: "This list contains all devices that the user marked as ",
  SELECTED_DEVICES_POPUP_1_2: "belonging to the current network segment.",

  SELECTED_DEVICES_POPUP_2_1: "It is important to emphasize that after clicking the ",
  SELECTED_DEVICES_POPUP_2_2: "Save",
  SELECTED_DEVICES_POPUP_2_3: " button, the DP Physical Layer section ",
  SELECTED_DEVICES_POPUP_2_4: "will only monitor the devices that are in the selected devices list.",

  SELECTED_DEVICES_POPUP_3_1: "This means that:",
  SELECTED_DEVICES_POPUP_3_2: " Devices that are not in this list will not be shown on the DP Physical Layer screens, such as: Live List, Matrix, Oscilloscope, Bar graph, etc.",

  CONFIRM_SEARCH_START: "Are you sure you want to start the search?",

  CONFIRM_SEARCH_START_POPUP_1_1: "The device search procedure will take ",
  CONFIRM_SEARCH_START_POPUP_1_2: "5 (five) minutes",
  CONFIRM_SEARCH_START_POPUP_1_3: " to complete.",

  CONFIRM_SEARCH_START_POPUP_2_1: " During the search ",
  CONFIRM_SEARCH_START_POPUP_2_2: "various internal procedures of TS Monitor PROFIBUS PRO will be restarted",
  CONFIRM_SEARCH_START_POPUP_2_3: ", and for this reason, it will only return to normal operation after the search is completed.",

  SEARCHING_DEVICES: "Searching for devices.",
  PLEASE_STAY_IN_PAGE: "Please remain on the page to follow the search progress.",

  SENDING_DEVICES_INFO: "Sending information about the devices, please wait.",

  // ---------------------------- LANGUAGE ----------------------------
  PORTUGUESE: "Portuguese",
  ENGLISH: "English",
  SPANISH: "Spanish",
  GERMAN: "German",
  UPDATING_LANGUAGE_WAITING: "Changing language, wait a moment",
  UNABLE_TO_ALTER_LANGUAGE: "Unable to change the program's language.\n",

  // ---------------------------- SHARED STRINGS ----------------------------
  MONITORING: "Protocol",
  PHYS_MEDIUM: "Physical Medium DP",
  GENERAL: "General",
  TS_EXPERT_PROT: "TS Expert - Protocol",
  TS_EXPERT_DP: "TS Expert - Physical Medium DP",
  TS_EXPERT_OF: "TS Expert - Optic Fiber",
  HEADER_TEXT_PRO: "Data Report - TS Monitor PROFIBUS PRO",
  PHYS_MEDIUM_DOTS: "................................................................................................",
  MONITORING_DOTS: "...................................................................................................................",
  DISCLAIMER_DOTS_PRO: "..............................................................................................................................",

  NETWORK_DP: "Network:",
  SEGMENT_DP: "Segment:",

  IP_ASSOCIATED_MONITOR: "IP of the associated monitor: ",
});

export default Constants;